// Early-available swatch placement function so we can run during parsing
window.updateSwatchPlacement = function () {
  try {
    var items = document.querySelectorAll('.product-item');
    items.forEach(function(item){
      var info = item.querySelector('.product-information');
      var swatch = item.querySelector('.quick-add-selector-wrapper--swatch');
      if (!info || !swatch) return;

      // reset before measuring
      item.classList.remove('swatch-below');

      var infoRect = info.getBoundingClientRect();
      var swatchRect = swatch.getBoundingClientRect();

      var overlaps = !(swatchRect.bottom <= infoRect.top ||
                       swatchRect.top >= infoRect.bottom ||
                       swatchRect.right <= infoRect.left ||
                       swatchRect.left >= infoRect.right);

      if (overlaps) {
        item.classList.add('swatch-below');
      }
    });
  } catch (e) {}
};

// Minimal early run to prevent visible jump
(function(){
  var ranEarly = false;
  function runEarly(){
    if (ranEarly) return; ranEarly = true;
    try { window.updateSwatchPlacement(); } catch(e) {}
  }
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    try { requestAnimationFrame(runEarly); } catch(e) { runEarly(); }
  } else {
    document.addEventListener('readystatechange', function(){
      if (document.readyState === 'interactive') {
        try { requestAnimationFrame(runEarly); } catch(e) { runEarly(); }
      }
    }, { once: true });
  }
})();

// Debounced global listeners (single setup to avoid duplicates)
(function(){
  var t;
  window.addEventListener('resize', function(){
    clearTimeout(t);
    t = setTimeout(function(){ try { window.updateSwatchPlacement(); } catch(e) {} }, 120);
  });
  // Also call on DOMContentLoaded and load as a fallback
  document.addEventListener('DOMContentLoaded', function(){ try { window.updateSwatchPlacement(); } catch(e) {} }, { once: true });
  window.addEventListener('load', function(){ try { window.updateSwatchPlacement(); } catch(e) {} }, { once: true });
})();

window.initProductListQuickAdd = function () {
  // --- PLP Swiper init (with native navigation) ---
  document.querySelectorAll('[data-product-image-swiper]').forEach(container => {
    if (container.swiper) return; // guard against re-init after load more
    
    // Count slides to determine if loop should be enabled
    const slideCount = container.querySelectorAll('.swiper-slide').length;
    
    const swiper = new Swiper(container, {
      slidesPerView: 1,
      roundLengths: true,
      loop: slideCount > 1,
      preloadImages: true, // Enable immediate image preloading
      lazy: false, // Disable lazy loading for immediate image display
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
      on: {
        init: function() {
          // Force immediate image loading for first slide
          const firstSlide = this.slides[0];
          if (firstSlide) {
            const lazyImages = firstSlide.querySelectorAll('.lazyload');
            lazyImages.forEach(img => {
              if (window.lazySizes && window.lazySizes.loader) {
                window.lazySizes.loader.unveil(img);
              }
            });
          }
          
          // Mark initial state
          this.el.setAttribute('data-expanded', this.slides.length > 1 ? '1' : '0');
          
          // Try to get the default color from the first checked radio
          const productItem = this.el.closest('.product-item');
          if (productItem) {
            const defaultRadio = productItem.querySelector('.quick-add-swatch__button input[type="radio"]:checked');
            if (defaultRadio) {
              this.el.setAttribute('data-current-color', defaultRadio.value);
            }
          }
        }
      }
    });
    container.swiper = swiper;
    container.setAttribute('data-plp-swiper-initialized','true');

    // Ensure gallery matches selected swatch
    try {
      var productItem = container.closest('.product-item');
      var selectedRadio = productItem && productItem.querySelector('.quick-add-swatch__button input[type="radio"]:checked');
      if (selectedRadio) {
        rebuildSwiperByColor(productItem, selectedRadio.value);
      }
    } catch (e) {}
  });
  // --- end Swiper init ---
  // prompt lazysizes to process any new lazy elements
  try {
    if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === 'function') {
      window.lazySizes.loader.checkElems();
    }
  } catch (e) {}
  var enableConsoleLogs = false;
  var enableBgConsoleLogs = false;
  var hoveredWrapper = null;
  var productWrappers = document.querySelectorAll(".quick-add-form[data-quick-add-product-id]");

  var storedVariantOption2 = sessionStorage.getItem("selectedVariantOption2");
  var storedVariantOption3 = sessionStorage.getItem("selectedVariantOption3");

  function isSizeRadio(radio) {
    return radio.name && radio.name.toLowerCase().includes("size");
  }

  function isOption3Radio(radio) {
    return radio.name && (radio.name.toLowerCase().includes("inseam") || radio.name.toLowerCase().includes("length"));
  }

  function detectMobileDevice() {
    return ('ontouchstart' in window) || window.matchMedia("(hover: none)").matches;
  }
  
  let isMobileDevice = detectMobileDevice();

  window.addEventListener("resize", function () {
    isMobileDevice = detectMobileDevice();
  });

  window.handleFinalSaleNotice = function(variant, form) {
    var compareAtPrice = parseFloat(variant.compare_at_price || 0);
    var price = parseFloat(variant.price || 0);
    
    var markedDownPrice = compareAtPrice > 0 && price > 0 && 
      (100 * (compareAtPrice - price) / compareAtPrice >= 60);
      
    var existingNoticeField = form.querySelector("input[name='properties[NOTICE]'][value='Final Sale']");
    var existingLPROField = form.querySelector("input[name='properties[_LPROP]']");
    
    if (variant.available && markedDownPrice) {
      if (!existingNoticeField) {
        var fieldName = document.createElement("input");
        fieldName.setAttribute("name", "properties[NOTICE]");
        fieldName.setAttribute("value", "Final Sale");
        fieldName.setAttribute("type", "hidden");
        form.appendChild(fieldName);
      }
      
      if (!existingLPROField) {
        var fieldLPRO = document.createElement("input");
        fieldLPRO.setAttribute("name", "properties[_LPROP]");
        fieldLPRO.setAttribute("value", "Loop Final Sale");
        fieldLPRO.setAttribute("type", "hidden");
        form.appendChild(fieldLPRO);
      }
    } else {
      if (existingLPROField) {
        form.removeChild(existingLPROField);
      }
      
      if (existingNoticeField) {
        form.removeChild(existingNoticeField);
      }
    }
  };

  productWrappers.forEach(function (wrapper) {
    if (wrapper.getAttribute('data-quick-add-initialized') === '1') return;
    wrapper.setAttribute('data-quick-add-initialized', '1');
    function rebuildSwiperByColor(productItem, selectedColorRaw, options) {
      options = options || {};
      var firstOnly = options.firstOnly === true;
      var maxSlides = options.maxSlides || 4;
      if (!productItem || !selectedColorRaw) return;
      var swiperContainer = productItem.querySelector('.swiper-container');
      if (!swiperContainer) return;
      var hasSwiper = !!swiperContainer.swiper;
      var dbgProductId = swiperContainer && swiperContainer.getAttribute('data-product-id');
      var isDbg = dbgProductId === '7793233002614';
      
      // Always rebuild for the selected color; being "expanded" does not guarantee slides match the color

      // Normalize color for resilient matching (handles case/spacing differences)
      var normalizedSelected = String(selectedColorRaw).trim().toLowerCase();

      var variantData = [];
      try {
        var scriptTag = productItem.querySelector('script[type="application/json"][data-variant-metafields-product-id]');
        if (scriptTag) {
          variantData = JSON.parse(scriptTag.textContent.trim()) || [];
        }
      } catch (e) {
        variantData = [];
      }

      var imagesObj = null;
      for (var i = 0; i < variantData.length; i++) {
        if (variantData[i] && Array.isArray(variantData[i].product_images)) {
          imagesObj = variantData[i];
          break;
        }
      }

      var slides = [];
      function normalizeColorLabel(str) {
        if (!str) return '';
        return String(str)
          .toLowerCase()
          .replace(/&/g, 'and')
          .replace(/[\/_]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }
      var normalizedSelected = normalizeColorLabel(selectedColorRaw);
      if (imagesObj && Array.isArray(imagesObj.product_images)) {
        var filtered = imagesObj.product_images
          .filter(function(img){
            if (!img || !img.alt) return false;
            var altNormalized = normalizeColorLabel(img.alt);
            return altNormalized === normalizedSelected;
          })
          .slice(0, firstOnly ? 1 : maxSlides);

        var linkEl = swiperContainer.querySelector('.product-link');
        var linkHref = linkEl ? linkEl.getAttribute('href') : '#';
        var linkAria = linkEl ? linkEl.getAttribute('aria-label') : '';

        slides = filtered.map(function(img, idx){
          if (img.media_type === 'video' && Array.isArray(img.sources) && img.sources.length) {
            var mp4 = img.sources.find(function(s){ return s.format === 'mp4'; }) || img.sources[0];
            var videoUrl = mp4 && mp4.url ? mp4.url : '';
            var posterUrl = (img && img.preview_image && (img.preview_image.src || img.preview_image)) || '';
            var bgStyle = (idx === 0 && posterUrl) ? ' style="background-image:url(\'' + posterUrl + '\')"' : '';
            var posterAttr = posterUrl ? ' poster="' + posterUrl + '"' : '';
            return '<div class="swiper-slide">\
  <a class="product-link" href="' + linkHref + '" aria-label="' + linkAria + '">\
    <div class="product-item__bg"' + bgStyle + '>\
      <video src="' + videoUrl + '"' + posterAttr + ' autoplay muted loop playsinline style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;"></video>\
    </div>\
  </a>\
</div>';
          }
          var src = (img && (img.src || (img.preview_image && img.preview_image.src))) || '';
          var extra = idx === 0 ? ' style="background-image:url(\'' + src + '\')"' : '';
          return '<div class="swiper-slide">\
  <a class="product-link" href="' + linkHref + '" aria-label="' + linkAria + '">\
    <div class="product-item__bg' + (idx !== 0 ? ' lazyload' : '') + '"' + (idx !== 0 ? ' data-bgset="' + generateResponsiveDataBgset(src) + '"' : '') + extra + '>\
      &nbsp;\
    </div>\
  </a>\
</div>';
        });
      }

      if (slides.length && swiperContainer.swiper) {
        var s = swiperContainer.swiper;
        var isExpanding = !firstOnly && s.slides && s.slides.length === 1 && swiperContainer.getAttribute('data-expanded') !== '1';
        var shouldEnableLoop = slides.length > 1;
        var needsLoopRebuild = (shouldEnableLoop && !s.params.loop) || (!shouldEnableLoop && s.params.loop);

        if (needsLoopRebuild) {
          // Only rebuild if the slides are actually different
          var currentSlideHtmls = Array.from(s.slides).map(slide => slide.innerHTML);
          var newSlideHtmls = slides.map(slide => {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = slide;
            return tempDiv.innerHTML;
          });
          
          // Check if slides content is actually different
          var slidesAreDifferent = currentSlideHtmls.length !== newSlideHtmls.length || 
            currentSlideHtmls.some((html, index) => html !== newSlideHtmls[index]);
          
          if (slidesAreDifferent) {
            // Destroy and recreate swiper with proper loop setting
            var currentIndex = s.activeIndex || 0;
            s.destroy(false, true);
            
            var newSwiper = new Swiper(swiperContainer, {
              slidesPerView: 1,
              roundLengths: true,
              loop: shouldEnableLoop,
              preloadImages: true,
              lazy: false,
              navigation: {
                nextEl: swiperContainer.querySelector('.swiper-button-next'),
                prevEl: swiperContainer.querySelector('.swiper-button-prev'),
              },
            });
            swiperContainer.swiper = newSwiper;

            // Hide arrows on touch/mobile after rebuild
            try {
              var isTouchOrMobile = ('ontouchstart' in window) || window.matchMedia('(hover: none)').matches || window.matchMedia('(max-width: 749px)').matches;
              if (isTouchOrMobile) {
                var prevBtnRe = swiperContainer.querySelector('.swiper-button-prev');
                var nextBtnRe = swiperContainer.querySelector('.swiper-button-next');
                if (prevBtnRe) { prevBtnRe.style.display = 'none'; prevBtnRe.setAttribute('aria-hidden', 'true'); }
                if (nextBtnRe) { nextBtnRe.style.display = 'none'; nextBtnRe.setAttribute('aria-hidden', 'true'); }
              }
            } catch(e) {}
            
            // Add slides to new swiper
            newSwiper.removeAllSlides();
            newSwiper.appendSlide(slides);
            newSwiper.update();
            if (shouldEnableLoop && typeof newSwiper.loopFix === 'function') {
              newSwiper.loopFix();
            }
            newSwiper.slideTo(0, 0);
          } else {
            // Just update loop setting without rebuilding slides
            s.params.loop = shouldEnableLoop;
            if (shouldEnableLoop && typeof s.loopFix === 'function') {
              s.loopFix();
            }
          }
        } else if (isExpanding) {
          var appendSlides = slides.slice(1); // keep first slide intact to avoid flicker
          if (appendSlides.length) {
            s.appendSlide(appendSlides);
            s.update();
            if (s.params.loop && typeof s.loopFix === 'function') s.loopFix();
          }
        } else {
          s.removeAllSlides();
          s.appendSlide(slides);
          s.update();
          if (s.params.loop && typeof s.loopFix === 'function') s.loopFix();
          s.slideToLoop(0, 0);
        }

        // trigger lazysizes unveil for newly appended backgrounds
        try {
          if (window.lazySizes && typeof window.lazySizes.loader.unveil === 'function') {
            var lazyNodes = swiperContainer.querySelectorAll('.lazyload:not(.lazyloaded)');
            lazyNodes && lazyNodes.forEach(function(node){
              window.lazySizes.loader.unveil(node);
            });
          }
        } catch(e) {}
        swiperContainer.setAttribute('data-expanded', firstOnly ? '0' : '1');
        swiperContainer.setAttribute('data-current-color', selectedColorRaw);
      }
    }

    var productId = wrapper.getAttribute("data-quick-add-product-id");
    var productItem = wrapper.closest('.product-item');

    wrapper.addEventListener("mouseenter", function () {
      enableConsoleLogs && console.log("[Debug] Hover on wrapper => ", wrapper);
      hoveredWrapper = wrapper;
    });

    wrapper.addEventListener("mouseleave", function () {
      if (hoveredWrapper === wrapper) {
        hoveredWrapper = null;
      }
    });

    // Expand gallery (load remaining images) on hover or arrow interaction
    var swiperContainerForInit = productItem && productItem.querySelector('.swiper-container');
    function expandGalleryIfNeeded() {
      if (!productItem || !swiperContainerForInit) return;
      if (swiperContainerForInit.getAttribute('data-expanded') === '1') return;
      
      // Check if swiper already has multiple slides - if so, just mark as expanded
      var swiper = swiperContainerForInit.swiper;
      if (swiper && swiper.slides && swiper.slides.length > 1) {
        swiperContainerForInit.setAttribute('data-expanded', '1');
        return;
      }
      
      try {
        var selectedRadio = wrapper.querySelector('.quick-add-swatch__button input[type="radio"]:checked');
        if (selectedRadio) {
          // Only rebuild if this is a different color than currently displayed
          var currentColor = swiperContainerForInit.getAttribute('data-current-color');
          if (currentColor !== selectedRadio.value) {
            rebuildSwiperByColor(productItem, selectedRadio.value, { firstOnly: false, maxSlides: 4 });
          } else {
            // Just mark as expanded if it's the same color
            swiperContainerForInit.setAttribute('data-expanded', '1');
          }
        }
      } catch (e) {}
    }
    if (swiperContainerForInit) {
      swiperContainerForInit.addEventListener('mouseenter', expandGalleryIfNeeded);
      swiperContainerForInit.addEventListener('touchstart', expandGalleryIfNeeded, { passive: true });
      var nextBtn = swiperContainerForInit.querySelector('.swiper-button-next');
      var prevBtn = swiperContainerForInit.querySelector('.swiper-button-prev');
      [nextBtn, prevBtn].forEach(function(btn){
        if (!btn) return;
        // Use capture to expand before Swiper processes the click
        btn.addEventListener('mousedown', expandGalleryIfNeeded, true);
        btn.addEventListener('click', expandGalleryIfNeeded, true);
      });
      // As a fallback, expanding when the wrapper itself is hovered
      wrapper.addEventListener('mouseenter', expandGalleryIfNeeded);

      // On touch/mobile devices, auto-expand to load up to 4 images for default color
      try {
        var isTouch = ('ontouchstart' in window) || window.matchMedia('(hover: none)').matches;
        if (isTouch && swiperContainerForInit.getAttribute('data-expanded') !== '1') {
          // Defer to avoid blocking main thread and ensure Swiper is ready
          setTimeout(function(){
            try { expandGalleryIfNeeded(); } catch(e) {}
          }, 0);
        }
      } catch(e) {}
    }

    var form = wrapper.querySelector("[data-product-form]");
    if (!form) {
      return;
    }

    var productJSONEl = wrapper.querySelector("[data-product-json]");
    if (!productJSONEl) {
      return;
    }

    var productData = JSON.parse(productJSONEl.textContent);

    var variantMetaEl = wrapper.querySelector('script[type="application/json"][data-variant-metafields-product-id="' + productId + '"]');
    var variantMetaData = [];
    if (variantMetaEl) {
      try {
        variantMetaData = JSON.parse(variantMetaEl.textContent.trim()) || [];
      } catch (e) {
        variantMetaData = [];
      }
    }

    if (productItem) {
      initializeProductBadge(productItem, productId, variantMetaData);
    }

    function selectLeadColorway(productId, variantMetaData) {
      var currentUrl = window.location.href;
      var collectionMatch = currentUrl.match(/\/collections\/([^\/\?#]+)/);
      if (!collectionMatch) {
        return;
      }
      var currentCollectionHandle = collectionMatch[1];
      var leadColorwayData = null;
      if (variantMetaData && Array.isArray(variantMetaData)) {
        var leadColorwayItem = variantMetaData.find(function(item) {
          return item && item.hasOwnProperty('plp_lead_colorway');
        });
        if (leadColorwayItem && Array.isArray(leadColorwayItem.plp_lead_colorway)) {
          leadColorwayData = leadColorwayItem.plp_lead_colorway;
        }
      }

      if (!leadColorwayData || leadColorwayData.length === 0) {
        return;
      }

      var targetColor = null;
      leadColorwayData.forEach(function(leadItem) {
        if (typeof leadItem === 'string' && leadItem.includes(',')) {
          var parts = leadItem.split(',');
          if (parts.length >= 2) {
            var collectionUrl = parts[0].trim();
            var colorName = parts[1].trim();
            
            var isMatch = false;
            if (collectionUrl.includes('/collections/')) {
              // Extract the handle part only (after /collections/)
              var handle = collectionUrl.split('/collections/')[1]?.split(/[/?#]/)[0];
              isMatch = handle === currentCollectionHandle;
            } else {
              isMatch = collectionUrl === currentCollectionHandle;
            }
            
            if (isMatch) {
              targetColor = colorName;
            }
          }
        }
      });

      if (!targetColor) {
        return;
      }

      var wrapper = document.querySelector('.quick-add-form[data-quick-add-product-id="' + productId + '"]');
      if (!wrapper) {
        return;
      }

      var colorSwatches = wrapper.querySelectorAll('.quick-add-swatch__button');
      
      var colorFound = false;
      colorSwatches.forEach(function(swatch) {
        var radio = swatch.querySelector('input[type="radio"]');
        if (radio && radio.value.toLowerCase() === targetColor.toLowerCase()) {
          var form = wrapper.querySelector("[data-product-form]");
          var allColorRadios = form.querySelectorAll('.quick-add-swatch__button input[type="radio"]');
          allColorRadios.forEach(function(colorRadio) {
            colorRadio.checked = false;
            var label = form.querySelector("label[for='" + colorRadio.id + "']");
            if (label) {
              label.classList.remove("selected");
            }
          });
          
          radio.checked = true;
          var targetLabel = form.querySelector("label[for='" + radio.id + "']");
          if (targetLabel) {
            targetLabel.classList.add("selected");
          }
          
          swatch.style.order = '-1';
          
          colorFound = true;
          
          var productItem = wrapper.closest('.product-item');
          if (productItem) {
            if (productId === '7793233002614') {
              try { console.log('[PLP DEBUG] selectLeadColorway applying targetColor', targetColor, 'radio.value', radio.value); } catch (e) {}
            }
            updateProductInfo(productItem, swatch);
            rebuildSwiperByColor(productItem, radio.value);
          }
          
          updateRadioAvailability();
          
          setTimeout(function() {
            hideSelectedVariants(productId);
            Promise.resolve().then(() => applySelectedColorMediaToBg(productId));
          }, 10);
        }
      });
    }

    function variantIsIgnored(variantId) {
      var meta = variantMetaData.find(function (m) {
        return m.id === variantId;
      });
      return meta && meta.visibility === true;
    }

    var totalOptionsCount = Array.isArray(productData.options) ? productData.options.length : 1;
    var allRadios = form.querySelectorAll('input[type="radio"][data-single-option-selector]');
    const hasOption3 = Array.from(allRadios).some(radio => isOption3Radio(radio));

    function updateRadioAvailability() {
      var selectedSet = Array.from(form.querySelectorAll("input[data-single-option-selector]:checked")).map(function (r) {
        var dimensionIndex = parseInt(r.getAttribute("data-index").replace("option", ""), 10) - 1;
        return {
          index: dimensionIndex,
          value: r.value,
          isSize: isSizeRadio(r),
          isOption3: isOption3Radio(r),
        };
      });

      var distinctOption3Values = [...new Set(productData.variants.map(v => v.option3))];
      distinctOption3Values.forEach(function (opt3Val) {
        var unavailableSizes = productData.variants
          .filter(function (variant) {
            if (variantIsIgnored(variant.id)) return false;
            return variant.option3 === opt3Val && variant.available === false;
          })
          .map(function (variant) {
            return variant.option2;
          });
      });

      var userHasSelectedOption3 = selectedSet.some(function (sel) {
        return sel.isOption3;
      });
      var userHasSelectedSize = selectedSet.some(function (sel) {
        return sel.isSize;
      });

      allRadios.forEach(function (radio) {
        if (!isSizeRadio(radio) && !isOption3Radio(radio)) return;
        var dimensionIndex = parseInt(radio.getAttribute("data-index").replace("option", ""), 10) - 1;
        var parentBtn = radio.closest(".quick-add-radio__button");
        if (parentBtn) parentBtn.classList.remove("no-stock");

        var hypothetical = selectedSet
          .filter(function (sel) {
            return sel.index !== dimensionIndex;
          })
          .concat([
            {
              index: dimensionIndex,
              value: radio.value,
              isSize: isSizeRadio(radio),
              isOption3: isOption3Radio(radio),
            },
          ])
          .sort(function (a, b) {
            return a.index - b.index;
          })
          .map(function (item) {
            return item.value;
          });

        var hasAvailableVariant = productData.variants.some(function (variant) {
          if (variantIsIgnored(variant.id)) return false;
          if (!variant.available) return false;
          return variant.options.every(function (option, i) {
            return option === hypothetical[i];
          });
        });

        radio.disabled = !hasAvailableVariant;
        if (!hasAvailableVariant && parentBtn) {
          if (hasOption3 && isOption3Radio(radio)) {
            var variantsForThisOpt3 = productData.variants.filter(function (v) {
              return v.option3 === radio.value && !variantIsIgnored(v.id);
            });

            var allNotAvailable = variantsForThisOpt3.every(function (v) {
              return !v.available;
            });

            if (allNotAvailable) {
              parentBtn.classList.add("no-stock");
              // console.log("[Debug] Marking option3 =>", radio.value, "as no-stock (all sizes unavailable for this option3)", productData.title);
            }
          } else if (isSizeRadio(radio)) {
            if (!userHasSelectedOption3) {
              var isCompletelyUnavailable = distinctOption3Values.every(function (opt3Val) {
                var unavailableSizes = productData.variants
                  .filter(function (variant) {
                    if (variantIsIgnored(variant.id)) return false;
                    return variant.option3 === opt3Val && !variant.available;
                  })
                  .map(function (variant) {
                    return variant.option2;
                  });
                return unavailableSizes.includes(radio.value);
              });
              if (isCompletelyUnavailable) {
                parentBtn.classList.add("no-stock");
              }
            } else {
              parentBtn.classList.add("no-stock");
            }
          }
        }
      });

      var colorSwatches = form.querySelectorAll(".quick-add-swatch__button");
      colorSwatches.forEach(function (swatch) {
        var colorRadio = swatch.querySelector('input[type="radio"][data-single-option-selector]');
        if (!colorRadio) return;
        var colorValue = colorRadio.value;
        swatch.classList.remove("no-stock");
        var allOutOfStock = true;
        productData.variants.forEach(function (variant) {
          if (variantIsIgnored(variant.id)) return;
          if (variant.available && variant.options.includes(colorValue)) {
            allOutOfStock = false;
          }
        });
        if (allOutOfStock) {
          swatch.classList.add("no-stock");
        }
      });
    }

    updateRadioAvailability();

    window.addEventListener("resize", function () {
      adjustSizeScrollHeightForProduct(productId);
    });

    var allSwatchRadios = form.querySelectorAll(".quick-add-swatch__button input[data-single-option-selector]");
    allSwatchRadios.forEach(function (radio) {
      radio.checked = false;
      var lbl = form.querySelector("label[for='" + radio.id + "']");
      if (lbl) {
        lbl.classList.remove("selected");
      }
      // Track manual user selection so we don't override it with lead color logic
      radio.addEventListener('change', function () {
        try { wrapper.setAttribute('data-user-selected', '1'); } catch (e) {}
      });
    });

    var firstSwatchRadio = form.querySelector(".quick-add-swatch__button input[data-single-option-selector]");
    var initialSelectedColorValue = null;
    if (firstSwatchRadio) {
      firstSwatchRadio.checked = true;
      var firstSwatchLabel = form.querySelector("label[for='" + firstSwatchRadio.id + "']");
      if (firstSwatchLabel) {
        firstSwatchLabel.classList.add("selected");
      }
      initialSelectedColorValue = firstSwatchRadio.value;
      var productItemForInit = wrapper.closest('.product-item');
      if (productItemForInit) {
        // Build full gallery (up to 4) for default color on init so swipe works on mobile
        rebuildSwiperByColor(productItemForInit, firstSwatchRadio.value, { firstOnly: false, maxSlides: 4 });
      }
    }

    setTimeout(function () {
      hideSelectedVariants(productId);
      Promise.resolve().then(() => applySelectedColorMediaToBg(productId));
      // Apply lead colorway for this collection unless the user has already made a manual selection
      try {
        var userSelectedManually = wrapper.getAttribute('data-user-selected') === '1';
        if (!userSelectedManually) {
          selectLeadColorway(productId, variantMetaData);
        }
      } catch(e) {}
      // Final enforcement: ensure swiper shows the CURRENTLY selected color's images
      try {
        var productItemEl = wrapper.closest('.product-item');
        var selectedRadioEl = wrapper.querySelector('.quick-add-swatch__button input[type="radio"]:checked');
        var enforcedColorValue = selectedRadioEl && selectedRadioEl.value; // prefer current selection (may be from lead colorway)
        if (productItemEl && enforcedColorValue) {
          rebuildSwiperByColor(productItemEl, enforcedColorValue, { firstOnly: false, maxSlides: 4 });
        }
      } catch (e) {}
    }, 0);

    var colorSwatches = form.querySelectorAll(".quick-add-swatch__button");

    function updateProductInfo(productItem, swatch) {
      var productLinkEls = productItem.querySelectorAll(".product-link");
      var selectedColor = swatch.querySelector("input[data-single-option-selector]").value;
      var matchingColorVariant = productData.variants.find(function (variant) {
        return variant.option1 === selectedColor;
      });

      if (matchingColorVariant && productLinkEls.length > 0) {
        productLinkEls.forEach(function(productLinkEl) {
          var originalHref = productLinkEl.getAttribute("href") || "";
          originalHref = originalHref.replace(/(\?|&)variant=\d+/, "");
          originalHref = originalHref.replace(/[?&]$/, "");

          if (originalHref.indexOf('?') === -1) {
            productLinkEl.setAttribute("href", originalHref + "?variant=" + matchingColorVariant.id);
          } else {
            var parts = originalHref.split("?");
            if (parts.length > 1) {
              var baseUrl = parts[0];
              var queryString = parts[1];
              var queryParts = queryString.split("&").filter(function (param) {
                return param && !param.startsWith("variant=");
              });
              queryParts.push("variant=" + matchingColorVariant.id);
              var newHref = baseUrl + "?" + queryParts.join("&");
              productLinkEl.setAttribute("href", newHref);
            } else {
              productLinkEl.setAttribute("href", originalHref + "?variant=" + matchingColorVariant.id);
            }
          }

          if (productLinkEl.hasAttribute("data-product-link")) {
            productLinkEl.setAttribute("data-product-link", productLinkEl.getAttribute("href"));
          }
        });
      }

      var newPriceEl = productItem.querySelector(".new-price");
      var oldPriceEl = productItem.querySelector(".old-price");

      if (matchingColorVariant && newPriceEl) {
        var currencySymbol = (newPriceEl.textContent.trim().match(/[^\d.,]+/) || [""])[0];

        var formatPrice = function (amount) {
          var parts = (amount / 100).toFixed(2).split(".");
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          if (currencySymbol === "$") {
            return currencySymbol + parts[0];
          }
          return currencySymbol + parts.join(".");
        };

        newPriceEl.textContent = formatPrice(matchingColorVariant.price);

        if (oldPriceEl) {
          var compareAt = parseFloat(matchingColorVariant.compare_at_price || 0);
          oldPriceEl.textContent = (compareAt > 0) ? formatPrice(compareAt) : "";
          oldPriceEl.style.display = "inline";
          oldPriceEl.style.visibility = "visible";
          oldPriceEl.style.opacity = "1";
        }

        window.handleFinalSaleNotice(matchingColorVariant, form);

        updateProductBadge(productItem, matchingColorVariant.id, productData.id);
      }
    }

    function handleSwatchInteraction(swatch, isTouchEvent = false) {
      if (!isTouchEvent && hoveredWrapper !== wrapper && document.activeElement !== swatch) return;
    
      setTimeout(function () {
        var scrollContainer = wrapper.querySelector(".scrollable-options-container");
        if (scrollContainer) {
          scrollContainer.scrollTop = scrollContainer.scrollHeight;
        }
      }, 100);
    
      // Hide the background under image on hover
      var productItem = wrapper.closest(".product-item");
      if (!productItem) return;
      var bgUnder = productItem.querySelector(".product-item__bg__under");
      var quickAddContainer = productItem.querySelector("#quick-add-container");
      if (quickAddContainer && bgUnder) {
        bgUnder.style.opacity = 0;
      }

      updateProductInfo(productItem, swatch);

      var radio = swatch.querySelector("input[data-single-option-selector]");
      if (!radio || radio.checked) return;
      radio.checked = true;
      enableConsoleLogs && console.log("[Option3 Debug] Hovered color =>", radio.value, productId);
    
      hideSelectedVariants(productId);
      Promise.resolve().then(() => applySelectedColorMediaToBg(productId));

      var productItem = wrapper.closest('.product-item');
      var selectedColorRaw = swatch.querySelector('input[data-single-option-selector]').value;
      rebuildSwiperByColor(productItem, selectedColorRaw, { firstOnly: false, maxSlides: 4 });

      var selectedOption = radio.getAttribute("data-index");
      var sameOptionRadios = form.querySelectorAll('input[data-index="' + selectedOption + '"]');
      sameOptionRadios.forEach(function (rd) {
        var lbl = form.querySelector("label[for='" + rd.id + "']");
        if (lbl) lbl.classList.remove("selected");
      });
      var labelForThis = form.querySelector("label[for='" + radio.id + "']");
      if (labelForThis) labelForThis.classList.add("selected");

      var selectedValues = Array.from(form.querySelectorAll("input[data-single-option-selector]:checked")).map(function (input) {
        return input.value;
      });
      if (selectedValues.length < totalOptionsCount) {
        enableConsoleLogs && console.log("[Option3 Debug] Not all selected yet on color hover");
        updateRadioAvailability();
        return;
      }
      var matchingVariant = productData.variants.find(function (variant) {
        return variant.options.every(function (option, i) {
          return option === selectedValues[i];
        });
      });
      if (matchingVariant) {
        var variantIDInput = form.querySelector('input[name="id"]');
        if (variantIDInput) {
          variantIDInput.value = matchingVariant.id;
          enableConsoleLogs && console.log("[Option3 Debug] Hover color => found variant ID:", matchingVariant.id);
        }

        window.handleFinalSaleNotice(matchingVariant, form);
      }
      updateRadioAvailability();
    }
    
    colorSwatches.forEach(function (swatch) {

      swatch.setAttribute("tabindex", "0");
      
      if (!isMobileDevice) {
        swatch.addEventListener("mouseenter", function () {
          var label = swatch.querySelector("label");
          if (!label || !label.classList.contains("selected")) {
            handleSwatchInteraction(swatch);
          }
        });
      }

      swatch.addEventListener("click", function (event) {
        if (isMobileDevice && event.detail === 0) {
          return;
        }
        var label = swatch.querySelector("label");
        if (!label || !label.classList.contains("selected")) {
          handleSwatchInteraction(swatch);
          // console.log("clicked swatch: ", swatch);
        }
      });

      swatch.addEventListener("focus", function () {
        var label = swatch.querySelector("label");
        if (!label) return; // Ensure label exists before modifying it
        
        label.classList.add("selected"); // Add 'selected' class to label
        handleSwatchInteraction(swatch); // Trigger the swatch interaction
      });
      
      swatch.addEventListener("blur", function () {
        var label = swatch.querySelector("label");
        if (!label) return; // Ensure label exists before modifying it
        
        label.classList.remove("selected"); // Remove 'selected' class
      });
      
    
      if (isMobileDevice) {
        swatch.addEventListener("touchstart", function (event) {
          event.preventDefault();
          var label = swatch.querySelector("label");
          if (!label || !label.classList.contains("selected")) {
            handleSwatchInteraction(swatch, true);
          }
        }, { passive: false });
      }
    });

    var radioLabels = wrapper.querySelectorAll(".quick-add-radio__button label");
    radioLabels.forEach(function (labelEl) {
      labelEl.addEventListener("click", function () {
        var inputEl = wrapper.querySelector("#" + labelEl.getAttribute("for"));
        if (!inputEl) {
          return;
        }
        enableConsoleLogs && console.log("[Debug] user clicked => ", inputEl.value);
        var clickedWrapper = inputEl.closest(".quick-add-form[data-quick-add-product-id]");
        if (!clickedWrapper) {
          return;
        }
        if (hoveredWrapper !== clickedWrapper) {
          return;
        }
        if (!inputEl.matches('input[type="radio"][data-single-option-selector]')) return;

        var isSize = isSizeRadio(inputEl);
        var isOpt3 = isOption3Radio(inputEl);

        if (!isSize && !isOpt3) {
          return;
        }

        inputEl.checked = true;
  
        var selectedOption = inputEl.getAttribute("data-index");
        var sameOptionRadios = form.querySelectorAll('input[data-index="' + selectedOption + '"]');
        sameOptionRadios.forEach(function (rd) {
          var lbl = form.querySelector("label[for='" + rd.id + "']");
          if (lbl) lbl.classList.remove("selected");
        });
        var thisLabel = form.querySelector("label[for='" + inputEl.id + "']");
        if (thisLabel) {
          thisLabel.classList.add("selected");
        }

        var hasOption3 = form.querySelector('.quick-add-selector-wrapper--option3') !== null;
        if (hasOption3) {
          var selectedSizeRadio = form.querySelector('.quick-add-selector-wrapper--size input[type="radio"]:checked');
          var selectedOpt3Radio = form.querySelector('.quick-add-selector-wrapper--option3 input[type="radio"]:checked');
          
          if (isSize && !selectedOpt3Radio) {
            form.setAttribute('data-selected-first', 'size');
          } else if (isOpt3 && !selectedSizeRadio) {
            form.setAttribute('data-selected-first', 'option3');
          }
        }

        setTimeout(function () {
          if (isOpt3) {
            hideSelectedVariants(productId);
          } else if (isSize) {
            hideSelectedVariants(productId);
          }
        }, 50);

        var selectedValues = Array.from(form.querySelectorAll("input[data-single-option-selector]:checked")).map(function (inp) {
          return inp.value;
        });
        if (!selectedValues.includes(inputEl.value)) {
          selectedValues.push(inputEl.value);
        }
        if (selectedValues.length < totalOptionsCount) {
          enableConsoleLogs && console.log("[Option3 Debug] Not all options selected => won't add to cart => productId:", correctId);
          updateRadioAvailability();
          return;
        }

        var correctId = hoveredWrapper.getAttribute("data-quick-add-product-id");
        var correctJSONEl = hoveredWrapper.querySelector("[data-product-json]");
        var correctProductData = JSON.parse(correctJSONEl.textContent);

        var matchingVariant = correctProductData.variants.find(function (variant) {
          return variant.options.every(function (option, i) {
            return option === selectedValues[i];
          });
        });

        if (matchingVariant && matchingVariant.available) {
          enableConsoleLogs && console.log("[Option3 Debug] Found matching variant => ID:", matchingVariant.id, " => productId:", correctId);
          var variantIDInput = form.querySelector('input[name="id"]');
          if (variantIDInput) {
            variantIDInput.value = matchingVariant.id;
            enableConsoleLogs && console.log("[Option3 Debug] Updated variant ID =>", matchingVariant.id);
          }

          window.handleFinalSaleNotice(matchingVariant, form);
          
          form.classList.add("is-loading");
          enableConsoleLogs && console.log("[Option3 Debug] Adding to cart => variant ID:", matchingVariant.id);

          var properties = {};
          var propFields = form.querySelectorAll('input[name^="properties["]');
          propFields.forEach(function(field) {
            var propName = field.name.match(/properties\[(.*?)\]/)[1];
            properties[propName] = field.value;
          });

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "xmlhttprequest",
            },
            body: JSON.stringify({
              items: [
                {
                  id: matchingVariant.id,
                  quantity: 1,
                  properties: properties
                },
              ],
            }),
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error("Add to cart error => " + response.statusText);
              }
              return response.json();
            })
            .then(function () {
              enableConsoleLogs && console.log("[Option3 Debug] Cart add SUCCESS => productId:", correctId);
              if (window.cart && typeof window.cart.getCart === "function") {
                window.cart.getCart();
              }
              if (form.classList.contains("is-loading")) {
                form.classList.remove("is-loading");
              }
              
              var hasOption3 = form.querySelector('.quick-add-selector-wrapper--option3') !== null;
              if (hasOption3) {
                var selectedFirst = form.getAttribute('data-selected-first');
                
                if (selectedFirst === 'size') {
                  var selectedOpt3Radio = form.querySelector('.quick-add-selector-wrapper--option3 input[type="radio"]:checked');
                  if (selectedOpt3Radio) {
                    selectedOpt3Radio.checked = false;
                    var opt3Label = form.querySelector('label[for="' + selectedOpt3Radio.id + '"]');
                    if (opt3Label) {
                      opt3Label.classList.remove("selected");
                    }
                  }
                } else if (selectedFirst === 'option3') {
                  var selectedSizeRadio = form.querySelector('.quick-add-selector-wrapper--size input[type="radio"]:checked');
                  if (selectedSizeRadio) {
                    selectedSizeRadio.checked = false;
                    var sizeLabel = form.querySelector('label[for="' + selectedSizeRadio.id + '"]');
                    if (sizeLabel) {
                      sizeLabel.classList.remove("selected");
                    }
                  }
                } else {
                  if (isSize) {
                    inputEl.checked = false;
                    if (thisLabel) {
                      thisLabel.classList.remove("selected");
                    }
                  } else if (isOpt3) {
                    enableConsoleLogs && console.log("[Option3 Debug] Keep option3 selected");
                  }
                }
                
                form.removeAttribute('data-selected-first');
              } else {
                if (isSize) {
                  inputEl.checked = false;
                  if (thisLabel) {
                    thisLabel.classList.remove("selected");
                  }
                }
              }
              
              updateRadioAvailability();
              setTimeout(function() {
                hideSelectedVariants(productId);
              }, 100);
            })
            .catch(function (error) {
              console.error("Error adding to cart => productId:", correctId, error);
            });
        } else {
          console.error("[Option3 Debug] No matching variant found => selectedValues:", selectedValues, " => productId:", correctId);
        }
        updateRadioAvailability();
      });
    });

    function initializeProductBadge(productItem, productId, variantMetaData) {
      var badgeContainer = productItem?.querySelector('[data-product-badge-container]');
      var quickAddForm = productItem?.querySelector('.quick-add-form[data-quick-add-product-id="' + productId + '"]');
      if (!badgeContainer || !quickAddForm) return;

      var mappedTag = badgeContainer.getAttribute('data-mapped-tag') || "";
      var currentCollectionUrl = badgeContainer.getAttribute('data-current-collection') || "";
      var excludedCollectionsData = badgeContainer.getAttribute('data-excluded-collections') || "";
      var excludedCollections = excludedCollectionsData ? excludedCollectionsData.split('|') : [];
      var excludeVariantBadgesData = badgeContainer.getAttribute('data-exclude-variant-badges') || "";
      var excludeVariantBadges = excludeVariantBadgesData ? excludeVariantBadgesData.split('|') : [];
      
      var retryCount = 0;
      var checkForSelectedColor = function() {
        var selectedLabel = quickAddForm.querySelector('.quick-add-swatch__button label.selected');
        if (!selectedLabel && retryCount < 50) {
          retryCount++;
          setTimeout(checkForSelectedColor, 100);
          return;
        }
    
        var selectedColor = quickAddForm.querySelector('#' + selectedLabel?.getAttribute('for'))?.value;
        if (!selectedColor || !variantMetaData) return;
    
        try {
          var shouldDisplay = true;
          if (currentCollectionUrl && excludedCollections.length > 0) {
            shouldDisplay = !excludedCollections.includes(currentCollectionUrl);
          }
          
          var variantWithBadge = variantMetaData.find(v => v?.color_option === selectedColor && v?.product_variant_badge);
          var badgeElement = badgeContainer.querySelector('.product-item__item-badge');
          
          var badgeText = "";
          var shouldExcludeBadge = false;
          
          if (variantWithBadge && variantWithBadge.product_variant_badge) {
            badgeText = variantWithBadge.product_variant_badge;
            shouldExcludeBadge = excludeVariantBadges.includes(badgeText.toLowerCase());
          } else if (mappedTag) {
            badgeText = mappedTag;
            shouldExcludeBadge = excludeVariantBadges.includes(badgeText.toLowerCase());
          }
          
          if (badgeElement && shouldDisplay && !shouldExcludeBadge) {
            if (badgeText) {
              badgeElement.textContent = badgeText;
              badgeContainer.style.display = 'block';
            } else {
              badgeContainer.style.display = 'none';
            }
          } else {
            badgeContainer.style.display = 'none';
          }
        } catch (e) {
          console.error('Error in badge display:', e);
        }
      };

      checkForSelectedColor();
    }
  });

  function hideSideOptionsOnHover() {
    var wrappers = document.querySelectorAll(".quick-add-selector-wrapper--swatch");
    wrappers.forEach(function (wrapper) {
      var sideOptions = wrapper.parentElement.querySelector(".quick-add-options-container--side");
      if (!sideOptions) return;
      wrapper.addEventListener("mouseenter", function () {
        sideOptions.style.display = "none";
      });
      wrapper.addEventListener("mouseleave", function () {
        sideOptions.style.display = "";
      });
    });
  }

  function adjustSwatchesWidth() {
    var productItems = document.querySelectorAll(".product-item");

    productItems.forEach(function (item) {
      var productLinkEl = item.querySelector(".product-link");
      if (!productLinkEl) return;
      var productLink = productLinkEl.getAttribute("href");

      var swatchWrapper = item.querySelector(".quick-add-selector-wrapper--swatch");
      if (!swatchWrapper) return;

      // Only consider truly visible and in-stock swatch buttons
      var swatchButtons = Array.from(swatchWrapper.querySelectorAll(".quick-add-swatch__button")).filter(function (btn) {
        if (btn.classList.contains("hide-variant")) return false;
        if (btn.classList.contains("no-stock")) return false;
        var style = window.getComputedStyle(btn);
        return style.display !== "none" && style.visibility !== "hidden";
      });

      // Reset any previous overflow-hiding
      swatchButtons.forEach(function (btn) {
        btn.classList.remove("hide-variant-color");
      });

      // Ensure we have a "+N" node
      var plusEl = swatchWrapper.querySelector(".more-swatches");
      if (!plusEl) {
        plusEl = createPlusLink(swatchWrapper, productLink);
      }
      // Exclude the "+N" node from width calculations
      if (plusEl && plusEl.parentElement && plusEl.parentElement.classList.contains('more-swatches-link')) {
        plusEl.parentElement.style.display = 'none';
      }

      // Measure available width relative to the product image container and wrapper anchor (left/right)
      var containerEl = item.querySelector('.product-item__image') || item;
      var containerWidth = containerEl ? containerEl.clientWidth : item.clientWidth;
      var wrapperCS = window.getComputedStyle(swatchWrapper);
      var leftPx = parseFloat(wrapperCS.left);
      var rightPx = parseFloat(wrapperCS.right);
      var availableWidth = containerWidth;
      if (!isNaN(leftPx)) {
        availableWidth = Math.max(0, containerWidth - leftPx);
      } else if (!isNaN(rightPx)) {
        availableWidth = Math.max(0, containerWidth - rightPx);
      }
      // Reserve some space for the "+N" indicator if needed (approx width)
      var plusReserve = 24;

      var usedWidth = 0;
      var visibleCount = 0;

      for (var i = 0; i < swatchButtons.length; i++) {
        var btn = swatchButtons[i];
        var cs = window.getComputedStyle(btn);
        var marginLeft = parseFloat(cs.marginLeft) || 0;
        var marginRight = parseFloat(cs.marginRight) || 0;
        var btnWidth = btn.offsetWidth + marginLeft + marginRight;

        // Keep room for the plus badge if any buttons will be hidden
        var remainingAfter = swatchButtons.length - (i + 1);
        var roomNeeded = usedWidth + btnWidth + (remainingAfter > 0 ? plusReserve : 0);
        if (roomNeeded <= availableWidth) {
          usedWidth += btnWidth;
          visibleCount++;
        } else {
          break;
        }
      }

      var hiddenCount = Math.max(0, swatchButtons.length - visibleCount);

      // Hide overflow buttons (only those considered in swatchButtons)
      for (var j = visibleCount; j < swatchButtons.length; j++) {
        swatchButtons[j].classList.add("hide-variant-color");
      }

      // Recompute hidden count from actual DOM state to ensure accuracy
      var actualHidden = Array.from(swatchWrapper.querySelectorAll('.quick-add-swatch__button'))
        .filter(function(btn){
          if (btn.classList.contains('hide-variant')) return false;
          if (btn.classList.contains('no-stock')) return false;
          if (btn.classList.contains('hide-variant-color')) return true;
          var style = window.getComputedStyle(btn);
          if (style.display === 'none' || style.visibility === 'hidden') return false;
          // return btn.classList.contains('hide-variant-color');
          return false;
        }).length;

      // Update "+N" using actual hidden swatches
      if (actualHidden > 0) {
        plusEl.textContent = "+" + actualHidden;
        plusEl.style.display = "block";
        if (plusEl.parentElement && plusEl.parentElement.classList.contains("more-swatches-link")) {
          plusEl.parentElement.style.display = "inline-block";
        }
      } else {
        plusEl.textContent = "";
        plusEl.style.display = "none";
        if (plusEl.parentElement && plusEl.parentElement.classList.contains("more-swatches-link")) {
          plusEl.parentElement.style.display = "none";
        }
      }
    });

    function createPlusLink(swatchWrapper, productLink) {
      if (productLink.indexOf('?') === -1) {
        productLink = productLink.replace('&', '?');
      }
      var plusLinkEl = document.createElement("a");
      plusLinkEl.href = productLink;
      plusLinkEl.classList.add("more-swatches-link");
      plusLinkEl.setAttribute("tabindex", "-1"); 
      plusLinkEl.setAttribute("aria-label", "View more swatches");

      var plusEl = document.createElement("span");
      plusEl.classList.add("more-swatches");

      plusLinkEl.appendChild(plusEl);
      swatchWrapper.appendChild(plusLinkEl);
      return plusEl;
    }
  }

  function getHiddenSwatchColors(wrapper) {
    return Array.from(wrapper.querySelectorAll('.quick-add-swatch__button.hide-variant input'))
      .map(input => input.value.toLowerCase().trim());
  }

  function applySelectedColorMediaToBg(productId) {
    var wrapper = document.querySelector('.quick-add-form[data-quick-add-product-id="' + productId + '"]');
    if (!wrapper) return;

    var currentCollectionPage = window.location.href.split("/collections/").pop().split(/[?#]/)[0];
    enableBgConsoleLogs && console.log("currentCollectionPage:", currentCollectionPage);

    var selectedColorLabel = wrapper.querySelector(".quick-add-swatch__button label.selected");
    if (!selectedColorLabel) return;

    var selectedColorWrapper = selectedColorLabel.closest(".quick-add-swatch__button");
    if (!selectedColorWrapper) return;
    var selectedColorInput = selectedColorWrapper.querySelector('input[type="radio"]');
    if (!selectedColorInput) return;

    var selectedColorValue = selectedColorInput.value;

    // Collect all hidden swatch colors
    const hiddenColors = getHiddenSwatchColors(wrapper);
    enableBgConsoleLogs && console.log("Hidden Colors:", hiddenColors);

    // Check if selected variant is hidden
    if (hiddenColors.includes(selectedColorValue.toLowerCase().trim())) {
      const oldPriceEl = wrapper.closest(".product-item")?.querySelector(".old-price");
      if (oldPriceEl) {
        oldPriceEl.style.display = "none";  // hide old price
        oldPriceEl.style.visibility = "hidden";
        oldPriceEl.style.opacity = "0";
        enableBgConsoleLogs && console.log("[HiddenVariant] Hiding old price for", selectedColorValue);
      }
    }

    var script = document.querySelector('script[type="application/json"][data-variant-metafields-product-id="' + productId + '"]');
    if (!script) return;

    var data = JSON.parse(script.textContent.trim());
    enableBgConsoleLogs && console.log("data:", data, "productId:", productId);

    var imagesObj = data.find(function (item) {
      return item && item.product_images;
    });

    var firstColorImage = null;
    if (imagesObj && Array.isArray(imagesObj.product_images)) {
      firstColorImage = imagesObj.product_images.find(function (img) {
        return img.alt === selectedColorValue;
      });
    }

    var normalizedSelectedColor = selectedColorValue.replace(/\s+/g, "-").toLowerCase().trim();

    for (var i = 0; i < data.length; i++) {
      var variant = data[i];

      var variantColorRaw = "";
      if (variant.featured_media && variant.featured_media.alt) {
        variantColorRaw = variant.featured_media.alt;
      } else if (variant.title) {
        var slashIndex = variant.title.indexOf("/");
        variantColorRaw = slashIndex > -1 ? variant.title.substring(0, slashIndex).trim() : variant.title.trim();
      }

      var variantColor = variantColorRaw.replace(/\s+/g, "-").toLowerCase().trim();

      if (variantColor === normalizedSelectedColor) {
        enableBgConsoleLogs && console.log("[ColorMatchFound]", "variantColor:", variantColorRaw, "selectedColorValue:", selectedColorValue, "product_title:", variant.product_title);

        var productItem = wrapper.closest(".product-item");
        if (!productItem) return;

        // mainBg may not exist when Swiper is used exclusively; guard all uses
        var mainBg = productItem.querySelector("[data-product-image-default]");
        var bgUnder = productItem.querySelector(".product-item__bg__under");
        var quickAddContainer = productItem.querySelector("#quick-add-container");

        // Adjust color variant price
        var newPriceEl = productItem.querySelector(".new-price");
        var oldPriceEl = productItem.querySelector(".old-price");

        if (variant && newPriceEl) {
          var symbolMatch = newPriceEl.textContent.trim().match(/[^\d.,]+/);
          var currencySymbol = symbolMatch ? symbolMatch[0] : "";

          function formatVariantPrice(price) {
            var p = (price / 100).toFixed(2).split(".");
            p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return currencySymbol === "$" ? p[0] : p.join(".");
          }

          newPriceEl.textContent = currencySymbol + formatVariantPrice(variant.price);

          if (oldPriceEl && variant.compare_at_price) {
            oldPriceEl.textContent = currencySymbol + formatVariantPrice(variant.compare_at_price);
          }
        }

        if (variant.plp_leading_asset || variant.plp_leading_asset_multi_line) {
          enableBgConsoleLogs && console.log("[plp_leading_asset] productId:", productId, (variant.plp_leading_asset_multi_line || variant.plp_leading_asset), "product_title:", variant.product_title, productItem);

          if (mainBg) {
            mainBg.innerHTML = "";
            // mainBg.removeAttribute("data-bgset");
            mainBg.style.backgroundImage = "none";
          }

          var plpLeadingAsset = variant.plp_leading_asset_multi_line ? variant.plp_leading_asset_multi_line : variant.plp_leading_asset;
          var plpArray;
          if (Array.isArray(plpLeadingAsset)) {
            plpArray = plpLeadingAsset;
          } else {
            try {
              plpArray = JSON.parse(plpLeadingAsset);
            } catch (e) {
              plpArray = plpLeadingAsset.split(/,\s*(?=\[)/);
            }
          }
          
          // console.log('plpArray', plpArray, productItem, variant.product_title);
          enableBgConsoleLogs && console.log("[plpArray]", plpArray, "product_title:", variant.product_title);

          var matchedAssetUrl = null;
          var assetColorRegex = /\[(.*?)\]/;

          plpArray.forEach(function (item) {
            enableBgConsoleLogs && console.log("[plpItemCheck]", "item =>", item, "product_title:", variant.product_title);
            var assetColorMatch = item.match(assetColorRegex);
            if (assetColorMatch) {
              var assetColor = assetColorMatch[1].replace(/\s+/g, "-").toLowerCase().trim();
              enableBgConsoleLogs && console.log("[plpItemCheck]", "assetColor =>", assetColor, "normalizedSelectedColor =>", normalizedSelectedColor, "product_title:", variant.product_title);

              if (assetColor === normalizedSelectedColor) {
                if (item.includes(",")) {
                  var parts = item.split(",");
                  var collectionName = parts[0].split("]")[1];
                  if (collectionName && collectionName.trim().toLowerCase() === currentCollectionPage.toLowerCase()) {
                    matchedAssetUrl = parts[1].trim();
                    enableBgConsoleLogs && console.log("[MatchFound]", "matchedAssetUrl =>", matchedAssetUrl, "product_title:", variant.product_title);
                  }
                } else {
                  matchedAssetUrl = item;
                  enableBgConsoleLogs && console.log("[NoCommaCase]", "matchedAssetUrl =>", matchedAssetUrl, "product_title:", variant.product_title);
                }
              }
            }
          });

          if (matchedAssetUrl) {
            enableBgConsoleLogs && console.log("[plp_leading_asset MATCHED]", matchedAssetUrl, "product_title:", variant.product_title);

            var isVideoMp4 = matchedAssetUrl.toLowerCase().endsWith(".mp4");

            if (isVideoMp4) {
              // Replace Swiper slides with a single video slide
              var swiperContainer = productItem.querySelector('[data-product-image-swiper]');
              if (swiperContainer && swiperContainer.swiper) {
                var videoSlide = '<div class="swiper-slide"><div class="product-item__bg">' +
                  '<video src="' + matchedAssetUrl + '" autoplay muted loop playsinline style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;"></video>' +
                '</div></div>';
                swiperContainer.swiper.removeAllSlides();
                swiperContainer.swiper.appendSlide([videoSlide]);
                swiperContainer.swiper.update();
              } else {
                if (mainBg) {
                  mainBg.innerHTML = '<video src="' + matchedAssetUrl + '" autoplay muted loop playsinline style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;"></video>';
                }
              }
            } else {
              var swiperContainerImg = productItem.querySelector('[data-product-image-swiper]');
              if (swiperContainerImg && swiperContainerImg.swiper) {
                try {
                  var linkElLead = productItem.querySelector('.product-link');
                  var linkHrefLead = linkElLead ? linkElLead.getAttribute('href') : '#';
                  var linkAriaLead = linkElLead ? linkElLead.getAttribute('aria-label') : '';

                  // Build a gallery for the selected color with the matched asset first
                  var imgsForColor = [];
                  if (imagesObj && Array.isArray(imagesObj.product_images)) {
                    imgsForColor = imagesObj.product_images.filter(function(img){
                      return img && img.alt === selectedColorValue;
                    });
                  }

                  var normLead = String(matchedAssetUrl).replace(/^https?:/, '');
                  var orderedImgs = imgsForColor.slice();
                  var leadIndex = orderedImgs.findIndex(function(img){
                    var src = (img && (img.src || (img.preview_image && img.preview_image.src))) || '';
                    return String(src).replace(/^https?:/, '') === normLead;
                  });
                  if (leadIndex > 0) {
                    var leadItem = orderedImgs.splice(leadIndex, 1)[0];
                    orderedImgs.unshift(leadItem);
                  } else if (leadIndex === -1) {
                    // Prepend synthetic item for leading asset
                    orderedImgs.unshift({ media_type: 'image', src: matchedAssetUrl, preview_image: { src: matchedAssetUrl }, alt: selectedColorValue });
                  }

                  // Cap to 4 images
                  orderedImgs = orderedImgs.slice(0, 4);

                  var slideHtmls = orderedImgs.map(function(img){
                    var src = (img && (img.src || (img.preview_image && img.preview_image.src))) || matchedAssetUrl;
                    return '<div class="swiper-slide">\
  <a class="product-link" href="' + linkHrefLead + '" aria-label="' + linkAriaLead + '">\
    <div class="product-item__bg lazyload" data-bgset="' + generateResponsiveDataBgset(src) + '">\
      &nbsp;\
    </div>\
  </a>\
</div>';
                  });

                  var sImg = swiperContainerImg.swiper;
                  var shouldLoop = slideHtmls.length > 1;
                  sImg.removeAllSlides();
                  sImg.appendSlide(slideHtmls);
                  sImg.update();
                  try { sImg.params.loop = shouldLoop; if (shouldLoop && typeof sImg.loopFix === 'function') sImg.loopFix(); } catch(e) {}
                  try { sImg.slideTo(0, 0); } catch(e) {}
                  try { swiperContainerImg.setAttribute('data-expanded', '1'); swiperContainerImg.setAttribute('data-current-color', selectedColorValue); } catch(e) {}
                } catch(e) {
                  if (mainBg) {
                    mainBg.setAttribute("data-bgset", generateResponsiveDataBgset(matchedAssetUrl));
                  }
                }
              } else {
                if (mainBg) {
                  mainBg.setAttribute("data-bgset", generateResponsiveDataBgset(matchedAssetUrl));
                }
              }
              enableBgConsoleLogs && console.log("[mainBgSet] =>", matchedAssetUrl, "product_title:", variant.product_title);
            }
          } else {
            enableBgConsoleLogs && console.log("[No matchedAssetUrl] Using fallback data-bgset", "product_title:", variant.product_title);

            if (bgUnder && variant.featured_media && variant.featured_media.src) {
              bgUnder.setAttribute("data-bgset", generateResponsiveDataBgset(variant.featured_media.src));
              enableBgConsoleLogs && console.log("[bgUnderSet] =>", variant.featured_media.src, "product_title:", variant.product_title);
            }

            if (mainBg && firstColorImage) {
              mainBg.setAttribute("data-bgset", generateResponsiveDataBgset(firstColorImage.src));
              enableBgConsoleLogs && console.log("[mainBgSet] =>", firstColorImage.src, "product_title:", variant.product_title);
            }
          }
          if (bgUnder && variant.featured_media && variant.featured_media.src) {
            bgUnder.setAttribute("data-bgset", generateResponsiveDataBgset(variant.featured_media.src));
            enableBgConsoleLogs && console.log("[bgUnderSet] =>", variant.featured_media.src, "product_title:", variant.product_title);
          }
        } else {
          enableBgConsoleLogs && console.log("[plp_leading_asset] does NOT exist, using fallback data-bgset", "product_title:", variant.product_title);

          if (bgUnder && variant.featured_media && variant.featured_media.src) {
            bgUnder.setAttribute("data-bgset", generateResponsiveDataBgset(variant.featured_media.src));
            enableBgConsoleLogs && console.log("[bgUnderSet] =>", variant.featured_media.src, "product_title:", variant.product_title);
          }

          if (mainBg && firstColorImage) {
            mainBg.setAttribute("data-bgset", generateResponsiveDataBgset(firstColorImage.src));
            enableBgConsoleLogs && console.log("[mainBgSet] =>", firstColorImage.src, "product_title:", variant.product_title);
          }
        }

        if (firstColorImage && ((variant.featured_media && variant.featured_media.src === firstColorImage.src) || !variant.featured_media)) {
          var filteredImages = imagesObj.product_images.filter(function(img) {
            return img.alt === selectedColorValue;
          });
          if (filteredImages.length >= 2 && bgUnder) {
            bgUnder.setAttribute("data-bgset", generateResponsiveDataBgset(filteredImages[1].src));
            enableBgConsoleLogs && console.log("[bgUnderSet from 2nd image]", filteredImages[1].src, "product_title:", variant.product_title);
          }
        }
        
        if (quickAddContainer && bgUnder) {
          quickAddContainer.addEventListener("mouseleave", function () {
            enableBgConsoleLogs && console.log("[HoverEvent]", "#quick-add-container leave", "product_title:", variant.product_title);
            bgUnder.style.opacity = "";
          });
        }

        foundMatch = true;
        break;
      }
    }
  }

  function generateResponsiveDataBgset(baseUrl) {
    var breakpoints = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1600];
    return breakpoints.map(function(width) {
      return baseUrl + "&width=" + width + " " + width + "w";
    }).join(",");
  }

  // Shared helper to rebuild Swiper slides for a given color on a product card (works for exploded and regular PLPs)
  window.rebuildSwiperByColorGlobal = function(productItem, selectedColorRaw, options) {
    try {
      options = options || {};
      var firstOnly = options.firstOnly === true;
      var maxSlides = options.maxSlides || 4;
      if (!productItem || !selectedColorRaw) return;

      var swiperContainer = productItem.querySelector('.swiper-container');
      if (!swiperContainer || !swiperContainer.swiper) return;

      function normalizeColorLabel(str) {
        if (!str) return '';
        return String(str)
          .toLowerCase()
          .replace(/&/g, 'and')
          .replace(/[\/_]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }

      var normalizedSelected = normalizeColorLabel(selectedColorRaw);

      // Find product id for exploded or regular quick-add forms within this card
      var wrapperQuickAdd = productItem.querySelector('.quick-add-form[data-quick-add-product-id]');
      var explodedQuickAdd = productItem.querySelector('.quick-add-form[data-quick-add-exploded-product-id]');
      var productId = null;
      if (wrapperQuickAdd) productId = wrapperQuickAdd.getAttribute('data-quick-add-product-id');
      if (!productId && explodedQuickAdd) productId = explodedQuickAdd.getAttribute('data-quick-add-exploded-product-id');

      // Load variant metafields JSON (contains product_images grouped by color)
      var scriptTag = null;
      if (productId) {
        scriptTag = document.querySelector('script[type="application/json"][data-variant-metafields-product-id="' + productId + '"]');
      }
      if (!scriptTag) {
        scriptTag = productItem.querySelector('script[type="application/json"][data-variant-metafields-product-id]');
      }
      if (!scriptTag) return;

      var variantData = [];
      try { variantData = JSON.parse(scriptTag.textContent.trim()) || []; } catch (e) { variantData = []; }

      var imagesObj = null;
      for (var i = 0; i < variantData.length; i++) {
        if (variantData[i] && Array.isArray(variantData[i].product_images)) {
          imagesObj = variantData[i];
          break;
        }
      }

      var slides = [];
      if (imagesObj && Array.isArray(imagesObj.product_images)) {
        var filtered = imagesObj.product_images
          .filter(function(img){
            if (!img || !img.alt) return false;
            return normalizeColorLabel(img.alt) === normalizedSelected;
          })
          .slice(0, firstOnly ? 1 : maxSlides);

        var linkEl = swiperContainer.querySelector('.product-link') || productItem.querySelector('.product-link');
        var linkHref = linkEl ? linkEl.getAttribute('href') : '#';
        var linkAria = linkEl ? linkEl.getAttribute('aria-label') : '';

        slides = filtered.map(function(img, idx){
          if (img.media_type === 'video' && Array.isArray(img.sources) && img.sources.length) {
            var mp4 = img.sources.find(function(s){ return s.format === 'mp4'; }) || img.sources[0];
            var videoUrl = mp4 && mp4.url ? mp4.url : '';
            var posterUrl = (img && img.preview_image && (img.preview_image.src || img.preview_image)) || '';
            var bgStyle = (idx === 0 && posterUrl) ? ' style="background-image:url(\'' + posterUrl + '\')"' : '';
            var posterAttr = posterUrl ? ' poster="' + posterUrl + '"' : '';
            return '<div class="swiper-slide">\
  <a class="product-link" href="' + linkHref + '" aria-label="' + linkAria + '">\
    <div class="product-item__bg"' + bgStyle + '>\
      <video src="' + videoUrl + '"' + posterAttr + ' autoplay muted loop playsinline style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;"></video>\
    </div>\
  </a>\
</div>';
          }
          var src = (img && (img.src || (img.preview_image && img.preview_image.src))) || '';
          var extra = idx === 0 ? ' style="background-image:url(\'' + src + '\')"' : '';
          return '<div class="swiper-slide">\
  <a class="product-link" href="' + linkHref + '" aria-label="' + linkAria + '">\
    <div class="product-item__bg' + (idx !== 0 ? ' lazyload' : '') + '"' + (idx !== 0 ? ' data-bgset="' + generateResponsiveDataBgset(src) + '"' : '') + extra + '>\
      &nbsp;\
    </div>\
  </a>\
</div>';
        });
      }

      if (!slides.length) return;

      var s = swiperContainer.swiper;
      var shouldEnableLoop = slides.length > 1;
      // Basic rebuild: replace slides and ensure loop param reflects slide count
      try {
        s.removeAllSlides();
        s.appendSlide(slides);
        s.update();
        s.params.loop = shouldEnableLoop;
        if (shouldEnableLoop && typeof s.loopFix === 'function') s.loopFix();
        s.slideTo(0, 0);
      } catch(e) {}

      try { swiperContainer.setAttribute('data-expanded', firstOnly ? '0' : '1'); } catch(e) {}
      try { swiperContainer.setAttribute('data-current-color', selectedColorRaw); } catch(e) {}

      // Unveil any lazysizes nodes inside newly appended slides
      try {
        if (window.lazySizes && typeof window.lazySizes.loader.unveil === 'function') {
          var lazyNodes = swiperContainer.querySelectorAll('.lazyload:not(.lazyloaded)');
          lazyNodes && lazyNodes.forEach(function(node){ window.lazySizes.loader.unveil(node); });
        }
      } catch(e) {}
    } catch (err) {
      try { console.error('[Exploded] rebuildSwiperByColorGlobal error', err); } catch(e) {}
    }
  };

  function adjustSizeScrollHeightForProduct(productId) {
    var productForm = document.querySelector('.product-item .quick-add-form[data-quick-add-product-id="' + productId + '"]') || document.querySelector('.product-item .quick-add-form[data-quick-add-product-exploded-color-id="' + productId + '"]');
    if (!productForm) return;

    // Adjust height for opaque quick add
    var opaqueQuickAddContainer = productForm.closest("#quick-add-container.opaque-quick-add");
    if (opaqueQuickAddContainer) {
      var productItem = opaqueQuickAddContainer.closest('.product-item');
      var productImage = productItem ? productItem.querySelector('.product-item__image') : null;
      if (productImage) {
        var imageHeight = productImage.offsetHeight;
        var quickAddInner = opaqueQuickAddContainer.querySelector('.quick-add-options-container--side-opaque');
        if (quickAddInner) {
          quickAddInner.style.height = imageHeight + 'px';
        }
      }
    }

    var scrollContainer = productForm.querySelector(".scrollable-options-container");
    if (!scrollContainer) return;

    var allSizeButtons = productForm.querySelectorAll(".quick-add-selector-wrapper--size .quick-add-radio__button");
    var visibleSizeButtons = Array.from(allSizeButtons).filter(function (btn) {
      return !btn.classList.contains("hide-variant");
    });
    var countSizeButtons = visibleSizeButtons.length;

    var productItem = productForm.closest(".product-item");
    if (!productItem) return;

    var productImage = productItem.querySelector(".product-item__image");
    var productImageHeight = productImage ? productImage.offsetHeight : 0;

    var buttonHeight = 40;
    var totalNeededHeight = countSizeButtons * buttonHeight;
    var heightWithoutPadding = productImageHeight - 37;
    var arrowUp = scrollContainer.querySelector(".scroll-arrow-overlay-up");
    var arrowDown = scrollContainer.querySelector(".scroll-arrow-overlay-down");

    setTimeout(function () {
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }, 100);

    if (totalNeededHeight > productImageHeight) {
      scrollContainer.style.height = heightWithoutPadding + "px";
    } else {
      scrollContainer.style.height = "";
      if (arrowUp) arrowUp.style.display = "none";
      if (arrowDown) arrowDown.style.display = "none";
      return;
    }

    scrollContainer.scrollTop = scrollContainer.scrollHeight;

    if (arrowUp) {
      if (scrollContainer.scrollTop === 0) {
        arrowUp.style.display = "none";
      }
      arrowUp.addEventListener("click", function (event) {
        event.stopPropagation();
        scrollContainer.scrollTop = 0;
        arrowUp.style.display = "none";
        if (arrowDown) {
          arrowDown.style.display = "flex";
        }
      });
      scrollContainer.addEventListener("scroll", function () {
        if (scrollContainer.scrollTop === 0) {
          arrowUp.style.display = "none";
        } else {
          arrowUp.style.display = "flex";
        }
      });
    }

    if (arrowDown) {
      if (scrollContainer.scrollTop >= scrollContainer.scrollHeight - scrollContainer.clientHeight) {
        arrowDown.style.display = "none";
      }
      arrowDown.addEventListener("click", function (event) {
        event.stopPropagation();
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
        arrowDown.style.display = "none";
        if (arrowUp) {
          arrowUp.style.display = "flex";
        }
      });
      scrollContainer.addEventListener("scroll", function () {
        setTimeout(function () {
          if (scrollContainer.scrollTop === 0) {
            arrowDown.style.display = "flex";
          } else {
            arrowDown.style.display = "none";
          }
        }, 0);
      });
    }
  }

  function hideSelectedVariants(productId) {
    return new Promise(function (resolve) {
      var wrapper = document.querySelector('.quick-add-form[data-quick-add-product-id="' + productId + '"]');
      if (!wrapper) {
        resolve();
        return;
      }
      var selectedColorRadio = wrapper.querySelector('.quick-add-swatch__button input[type="radio"]:checked');
      if (!selectedColorRadio) {
        resolve();
        return;
      }
      var selectedColorValue = selectedColorRadio.value;
      var selectedOption3Radio = wrapper.querySelector('.quick-add-selector-wrapper--option3 input[type="radio"]:checked');
      var selectedOption3Value = selectedOption3Radio ? selectedOption3Radio.value : null;
      
      var sizeWrapper = wrapper.querySelector('.quick-add-selector-wrapper--size');
      var selectedSizeRadio = sizeWrapper ? sizeWrapper.querySelector('input[type="radio"]:checked') : null;
      var selectedSizeLabel = sizeWrapper ? sizeWrapper.querySelector('label.selected') : null;
      
      var selectedSizeValue = null;
      if (selectedSizeRadio) {
        selectedSizeValue = selectedSizeRadio.value;
      } 
      else if (selectedSizeLabel) {
        var sizeId = selectedSizeLabel.getAttribute('for');
        var sizeInput = wrapper.querySelector('#' + sizeId);
        if (sizeInput) {
          selectedSizeValue = sizeInput.value;
        }
      }
      
      var script = document.querySelector('script[type="application/json"][data-variant-metafields-product-id="' + productId + '"]');
      if (!script) {
        resolve();
        return;
      }
      var data;
      try {
        data = JSON.parse(script.textContent.trim());
      } catch (err) {
        resolve();
        return;
      }
      if (!Array.isArray(data)) {
        resolve();
        return;
      }

      var total = 0;
      var visibleCount = 0;
      var hasOption3 = data.some(function (variant) {
        if (!variant || !variant.title) return false;
        var parts = variant.title.split(" / ");
        return parts.length > 2;
      });

      var filteredVariants = data.filter(function (variant) {
        if (!variant || !variant.title) return false;
        var parts = variant.title.split(" / ");
        var variantColor = parts[0] || "";
        return variantColor === selectedColorValue;
      });

      var sizeRadios = wrapper.querySelectorAll('.quick-add-radio__button input[type="radio"]');
      sizeRadios.forEach(function (radioEl) {
        var parentButton = radioEl.closest(".quick-add-radio__button");
        if (parentButton.classList.contains("hide-variant")) {
          parentButton.classList.remove("hide-variant");
        }
      });

      var hiddenVariants = filteredVariants.filter(function (variant) {
        return variant.visibility === true;
      });

      if (selectedSizeValue && !selectedOption3Value && hasOption3) {
        var option3Radios = wrapper.querySelectorAll('.quick-add-selector-wrapper--option3 input[type="radio"]');
        
        option3Radios.forEach(function(option3Radio) {
          var option3Value = option3Radio.value;
          var parentButton = option3Radio.closest(".quick-add-radio__button");
          
          var hasHiddenVariant = hiddenVariants.some(function(variant) {
            if (!variant || !variant.title) return false;
            var parts = variant.title.split(" / ");
            if (parts.length < 3) return false;
            
            var variantSize = parts[1] || "";
            var variantOption3 = parts[2];
            
            return variantSize === selectedSizeValue && variantOption3 === option3Value;
          });
          
          if (hasHiddenVariant) {
            parentButton.classList.add("hide-variant");
          } else {
            parentButton.classList.remove("hide-variant");
          }
        });
      }

      if (selectedOption3Value) {
        var option3HiddenVariants = hiddenVariants.filter(function (variant) {
          if (!variant || !variant.title) return false;
          var parts = variant.title.split(" / ");
          if (parts.length < 3) return false;
          var variantOption3 = parts[2];
          return variantOption3 === selectedOption3Value;
        });

        option3HiddenVariants.forEach(function (variant) {
          var parts = variant.title.split(" / ");
          if (parts.length < 3) return;
          var variantSize = parts[1] || "";
          var sizeInputOpt3 = wrapper.querySelector('.quick-add-radio__button input[type="radio"][value="' + variantSize + '"]');
          if (sizeInputOpt3) {
            var parentOpt3 = sizeInputOpt3.closest(".quick-add-radio__button");
            if (parentOpt3) {
              parentOpt3.classList.add("hide-variant");
            }
          }
        });

        enableConsoleLogs && console.log("[Debug] selected option3HiddenVariants =>", option3HiddenVariants);

        return;
      }

      enableConsoleLogs && console.log("filteredVariants", filteredVariants, "total", filteredVariants.length, productId);

      filteredVariants.forEach(function (variant) {
        if (!variant || !variant.title) return;
        var parts = variant.title.split(" / ");
        var variantColor = parts[0] || "";
        var variantSize = parts[1] || "";
        var variantOption3 = parts.length > 2 ? parts[2] : null;
        var isVisible = variant.visibility === true;
        total++;
        if (isVisible) {
          visibleCount++;
        }
        if (hasOption3) {
          if (!selectedOption3Value && variantOption3) {
            var allForThisSizeVisible = data
              .filter(function (v) {
                if (!v || !v.title) return false;
                var pts = v.title.split(" / ");
                var c = pts[0] || "";
                var s = pts[1] || "";
                var o3 = pts.length > 2 ? pts[2] : null;
                return c === variantColor && s === variantSize && o3;
              })
              .every(function (v2) {
                return v2.visibility === true;
              });
            if (allForThisSizeVisible) {
              var sizeInputA = wrapper.querySelector('.quick-add-radio__button input[type="radio"][value="' + variantSize + '"]');
              if (sizeInputA) {
                var parentButtonA = sizeInputA.closest(".quick-add-radio__button");
                if (parentButtonA) {
                  parentButtonA.classList.add("hide-variant");
                }
              }
            } else {
              var sizeInputB = wrapper.querySelector('.quick-add-radio__button input[type="radio"][value="' + variantSize + '"]');
              if (sizeInputB) {
                var parentButtonB = sizeInputB.closest(".quick-add-radio__button");
                if (parentButtonB) {
                  if (isVisible) {
                    parentButtonB.classList.add("hide-variant");
                  } else {
                    parentButtonB.classList.remove("hide-variant");
                  }
                }
              }
            }
          } else if (selectedOption3Value && variantOption3 && variantOption3 !== selectedOption3Value) {
            var sizeInputC = wrapper.querySelector('.quick-add-radio__button input[type="radio"][value="' + variantSize + '"]');
            if (sizeInputC) {
              var parentButtonC = sizeInputC.closest(".quick-add-radio__button");
              if (parentButtonC) {
                parentButtonC.classList.add("hide-variant");
              }
            }
          } else if (variantOption3 === selectedOption3Value || !variantOption3) {
            var sizeInputD = wrapper.querySelector('.quick-add-radio__button input[type="radio"][value="' + variantSize + '"]');
            if (sizeInputD) {
              var parentButtonD = sizeInputD.closest(".quick-add-radio__button");
              if (parentButtonD) {
                if (isVisible) {
                  parentButtonD.classList.add("hide-variant");
                } else {
                  parentButtonD.classList.remove("hide-variant");
                }
              }
            }
          }
        } else {
          var sizeInputE = wrapper.querySelector('.quick-add-radio__button input[type="radio"][value="' + variantSize + '"]');
          if (sizeInputE) {
            var parentButtonE = sizeInputE.closest(".quick-add-radio__button");
            if (parentButtonE) {
              if (isVisible) {
                parentButtonE.classList.add("hide-variant");
              } else {
                parentButtonE.classList.remove("hide-variant");
              }
            }
          }
        }
      });

      // If ALL sizes for this color are "visibility===true", hide the color swatch itself.
      if (total > 0 && visibleCount === total) {
        var colorInput = wrapper.querySelector('.quick-add-swatch__button input[type="radio"][value="' + selectedColorValue + '"]');
        if (colorInput) {
          var colorButton = colorInput.closest(".quick-add-swatch__button");
          if (colorButton) {
            colorButton.classList.add("hide-variant");
            
            var colorVariants = data.filter(function(variant) {
              if (!variant || !variant.title) return false;
              var parts = variant.title.split(" / ");
              var variantColor = parts[0] || "";
              return variantColor === selectedColorValue;
            });
            
            var allVariantsHidden = colorVariants.every(function(variant) {
              return variant.visibility === true;
            });
            
            if (allVariantsHidden && colorVariants.length > 0) {
              hideProductItemForFilteredColor(wrapper, selectedColorValue, data);
            }
            
            var selectedLabel = colorButton.querySelector("label.selected");
            if (selectedLabel) {
              var allSwatches = Array.from(wrapper.querySelectorAll(".quick-add-swatch__button"));
              var nextVisibleSwatch = allSwatches.find(function (sw) {
                return !sw.classList.contains("hide-variant");
              });
              if (nextVisibleSwatch) {
                var nextRadio = nextVisibleSwatch.querySelector('input[type="radio"]');
                if (nextRadio) {
                  nextRadio.checked = true;
                  var lbl = wrapper.querySelector('label[for="' + nextRadio.id + '"]');
                  if (lbl) {
                    lbl.classList.add("selected");
                  }
                  var nextColorValue = nextRadio.value;
                  data.forEach(function (variant) {
                    if (!variant || !variant.title) return;
                    var parts = variant.title.split(" / ");
                    var variantColor = parts[0] || "";
                    var variantSize = parts[1] || "";
                    var isVisible = variant.visibility === true;
                    if (variantColor === nextColorValue) {
                      var sizeInput = wrapper.querySelector('.quick-add-radio__button input[type="radio"][value="' + variantSize + '"]');
                      if (sizeInput) {
                        var parentBtn = sizeInput.closest(".quick-add-radio__button");
                        if (parentBtn) {
                          if (isVisible) {
                            parentBtn.classList.add("hide-variant");
                          } else {
                            parentBtn.classList.remove("hide-variant");
                          }
                          if (!variant.available) {
                            parentBtn.classList.add("no-stock");
                          } else {
                            parentBtn.classList.remove("no-stock");
                          }
                        }
                      }
                    }
                  });
                }
              }
            }
          }
        }
      }

      var allSwatchRadios = wrapper.querySelectorAll('.quick-add-swatch__button input[type="radio"]');
      allSwatchRadios.forEach(function (colorRadio) {
        var cValue = colorRadio.value;
        var ctotal = 0;
        var cvisibleCount = 0;
        var cfilteredVariants = data.filter(function (variant) {
          if (!variant || !variant.title) return false;
          var parts = variant.title.split(" / ");
          var variantColor = parts[0] || "";
          return variantColor === cValue;
        });
        cfilteredVariants.forEach(function (variant) {
          if (!variant || !variant.title) return;
          var isVisible = variant.visibility === true;
          ctotal++;
          if (isVisible) {
            cvisibleCount++;
          }
        });
        if (ctotal > 0 && cvisibleCount === ctotal) {
          var cInput = wrapper.querySelector('.quick-add-swatch__button input[type="radio"][value="' + cValue + '"]');
          if (cInput) {
            var cButton = cInput.closest(".quick-add-swatch__button");
            enableConsoleLogs && console.log("hidden color", cInput, productId);
            if (cButton) {
              cButton.classList.add("hide-variant");
              var lbl = cButton.querySelector("label.selected");
              if (lbl) lbl.classList.remove("selected");
              hideProductItemForFilteredColor(wrapper, cValue, data);
            }
          }
        }
      });

      var visibleSwatchButtons = wrapper.querySelectorAll('.quick-add-swatch__button:not(.hide-variant)');
      if (visibleSwatchButtons.length === 1) {
        var productItemEl = wrapper.closest('.product-item');
        visibleSwatchButtons[0].classList.add("hide-swatch");
        productItemEl.classList.add('single-color');
      }

      resolve();
    }).then(function () {
      adjustSizeScrollHeightForProduct(productId);
    });
  }

  function replicateSelection(value, isOpt3, skipWrapper) {
    productWrappers.forEach(function (otherWrapper) {
      if (otherWrapper === skipWrapper) return;
      var otherForm = otherWrapper.querySelector("[data-product-form]");
      if (!otherForm) return;
      var radios = otherForm.querySelectorAll('input[type="radio"][data-single-option-selector]');

      // First, uncheck and remove "selected" from the same dimension
      radios.forEach(function (radio) {
        var label = otherForm.querySelector("label[for='" + radio.id + "']");
        if ((isOpt3 && isOption3Radio(radio)) || (!isOpt3 && isSizeRadio(radio))) {
          radio.checked = false;
          if (label) label.classList.remove("selected");
        }
      });

      // Then, check and add "selected" to the matching radio
      radios.forEach(function (radio) {
        if ((isOpt3 && isOption3Radio(radio) && radio.value === value) || (!isOpt3 && isSizeRadio(radio) && radio.value === value)) {
          radio.checked = true;
          var label = otherForm.querySelector("label[for='" + radio.id + "']");
          if (label) label.classList.add("selected");
        }
      });
    });
  }

  function handleExplodedVariants() {
    var explodedForms = document.querySelectorAll(".quick-add-form[data-quick-add-exploded-product-id]");

    if (!explodedForms) return;

    explodedForms.forEach(function (form) {
      var productId = form.getAttribute("data-quick-add-exploded-product-id");
      var explodedColor = form.getAttribute("data-exploded-color");
      var productJSONEl = form.querySelector("[data-product-json]");
      var explodedColorId = form.getAttribute("data-quick-add-product-exploded-color-id");
      if (!productJSONEl) return;

      var productData;
      try {
        productData = JSON.parse(productJSONEl.textContent.trim());
      } catch (error) {
        return;
      }
      if (!productData || !productData.variants) return;

      var variantMetaEl = form.querySelector('script[type="application/json"][data-variant-metafields-product-id="' + productId + '"]');
      var variantMetaData = [];
      if (variantMetaEl) {
        try {
          variantMetaData = JSON.parse(variantMetaEl.textContent.trim()) || [];
        } catch (e) {
          variantMetaData = [];
        }
      }

      enableConsoleLogs && console.log("Selected explodedColor: ", explodedColor);
      if (explodedColor) {
        var colorRadio = form.querySelector('input[data-single-option-selector][value="' + explodedColor + '"]');
        if (colorRadio) {
          colorRadio.checked = true;
          var labelEl = form.querySelector('label[for="' + colorRadio.id + '"]');
          if (labelEl) {
            labelEl.classList.add("selected");
            var swatchParent = labelEl.closest('.quick-add-swatch__button');
            if (swatchParent) {
              var swatchWrapper = swatchParent.closest('.quick-add-selector-wrapper--swatch');
              if (swatchWrapper) {
                swatchWrapper.insertBefore(swatchParent, swatchWrapper.firstChild);
              }
            }
          }
        }
      }

      function variantIsIgnored(variantId) {
        var meta = variantMetaData.find(function (m) {
          return m.id === variantId;
        });
        return meta && meta.visibility === true;
      }

      var relatedVariants = productData.variants.filter(function (v) {
        return v.title && v.title.includes(explodedColor);
      });

      if (relatedVariants.length === 0) {
        form.style.display = "none";
        return;
      } else {
        form.style.display = "";
      }

      function updateUI() {
        var sizeWrapper = form.querySelector(".quick-add-selector-wrapper--size");
        var opt3Wrapper = form.querySelector(".quick-add-selector-wrapper--option3");
        if (sizeWrapper) {
          var sizeRadios = sizeWrapper.querySelectorAll('input[type="radio"]');
          sizeRadios.forEach(function (radio) {
            var parentButton = radio.closest(".quick-add-radio__button");
            if (!parentButton) return;
            parentButton.classList.remove("hide-variant", "no-stock");
            var matching = relatedVariants.filter(function (v) {
              if (variantIsIgnored(v.id)) return false;
              return v.option2 === radio.value;
            });
            var selectedOpt3 = opt3Wrapper ? opt3Wrapper.querySelector('input[type="radio"]:checked') : null;
            if (selectedOpt3 && selectedOpt3.value) {
              matching = matching.filter(function (m) {
                return m.option3 === selectedOpt3.value;
              });
            }
            if (matching.length === 0) {
              parentButton.classList.add("hide-variant");
            } else {
              var anyAvailable = matching.some(function (m) {
                return m.available;
              });
              if (!anyAvailable) {
                parentButton.classList.add("no-stock");
              }
            }
          });
        }
        if (opt3Wrapper) {
          var opt3Radios = opt3Wrapper.querySelectorAll('input[type="radio"]');
          opt3Radios.forEach(function (radio) {
            var parentButton = radio.closest(".quick-add-radio__button");
            if (!parentButton) return;
            parentButton.classList.remove("hide-variant", "no-stock");
            var matching = relatedVariants.filter(function (v) {
              if (variantIsIgnored(v.id)) return false;
              return v.option3 === radio.value;
            });
            var selectedSize = sizeWrapper ? sizeWrapper.querySelector('input[type="radio"]:checked') : null;
            if (selectedSize && selectedSize.value) {
              matching = matching.filter(function (m) {
                return m.option2 === selectedSize.value;
              });
            }
            if (matching.length === 0) {
              parentButton.classList.add("hide-variant");
            } else {
              var anyAvailable = matching.some(function (m) {
                return m.available;
              });
              if (!anyAvailable) {
                parentButton.classList.add("no-stock");
              }
            }
          });
        }
      }

      updateUI();

      function applySelectedColorMediaToBgExploded() {
        var currentCollectionPage = window.location.href.split("/collections/").pop().split(/[?#]/)[0];
        enableBgConsoleLogs && console.log("currentCollectionPage:", currentCollectionPage);

        var selectedColorLabel = form.querySelector(".quick-add-swatch__button label.selected");
        if (!selectedColorLabel) return;

        var selectedColorInput = selectedColorLabel.closest(".quick-add-swatch__button").querySelector('input[type="radio"]');
        if (!selectedColorInput) return;

        var selectedColorValue = selectedColorInput.value;
        var script = document.querySelector('script[type="application/json"][data-variant-metafields-product-id="' + productId + '"]');
        if (!script) return;

        var data = JSON.parse(script.textContent.trim());
        enableBgConsoleLogs && console.log("data:", data, "productId:", productId);

        var imagesObj = data.find(function (item) {
          return item && item.product_images;
        });

        var firstColorImage = null;
        if (imagesObj && Array.isArray(imagesObj.product_images)) {
          firstColorImage = imagesObj.product_images.find(function (img) {
            return img.alt === selectedColorValue;
          });
        }

        var normalizedSelectedColor = selectedColorValue.replace(/\s+/g, "-").toLowerCase().trim();
        enableBgConsoleLogs && console.log("normalizedSelectedColor: ", normalizedSelectedColor);

        for (var i = 0; i < data.length; i++) {
          var variant = data[i];

          var variantColorRaw = "";
          if (variant.featured_media && variant.featured_media.alt) {
            variantColorRaw = variant.featured_media.alt;
          } else if (variant.title) {
            var slashIndex = variant.title.indexOf("/");
            variantColorRaw = slashIndex > -1 ? variant.title.substring(0, slashIndex).trim() : variant.title.trim();
          }

          var variantColor = variantColorRaw.replace(/\s+/g, "-").toLowerCase().trim();

          if (variantColor === normalizedSelectedColor) {
            enableBgConsoleLogs && console.log("[ColorMatchFound]", "variantColor:", variantColorRaw, "selectedColorValue:", selectedColorValue, "product_title:", variant.product_title);

            var productItem = form.closest(".product-item");
            if (!productItem) return;

            var mainBg = productItem.querySelector("[data-product-image-default]");
            var bgUnder = productItem.querySelector(".product-item__bg__under");
            var quickAddContainer = productItem.querySelector("#quick-add-container");

            updateProductBadge(productItem, variant.id, productId);

            if (variant.plp_leading_asset || variant.plp_leading_asset_multi_line) {
              enableBgConsoleLogs && console.log("[plp_leading_asset] productId:", productId, (variant.plp_leading_asset_multi_line || variant.plp_leading_asset), "product_title:", variant.product_title, productItem);

              if (mainBg) {
                mainBg.innerHTML = "";
                // mainBg.removeAttribute("data-bgset");
                mainBg.style.backgroundImage = "none";
              }

              var plpLeadingAsset = variant.plp_leading_asset_multi_line ? variant.plp_leading_asset_multi_line : variant.plp_leading_asset;
              var plpArray;
              if (Array.isArray(plpLeadingAsset)) {
                plpArray = plpLeadingAsset;
              } else {
                try {
                  plpArray = JSON.parse(plpLeadingAsset);
                } catch (e) {
                  plpArray = plpLeadingAsset.split(/,\s*(?=\[)/);
                }
              }
              // console.log('plpArray [EXPLODED]', plpArray, productItem, variant.product_title);

              enableBgConsoleLogs && console.log("[plpArray]", plpArray, "product_title:", variant.product_title);

              var matchedAssetUrl = null;
              var assetColorRegex = /\[(.*?)\]/;

              plpArray.forEach(function (item) {
                enableBgConsoleLogs && console.log("[plpItemCheck]", "item =>", item, "product_title:", variant.product_title);
                var assetColorMatch = item.match(assetColorRegex);
                if (assetColorMatch) {
                  var assetColor = assetColorMatch[1].replace(/\s+/g, "-").toLowerCase().trim();
                  enableBgConsoleLogs && console.log("[plpItemCheck]", "assetColor =>", assetColor, "normalizedSelectedColor =>", normalizedSelectedColor, "product_title:", variant.product_title);

                  if (assetColor === normalizedSelectedColor) {
                    if (item.includes(",")) {
                      var parts = item.split(",");
                      var collectionName = parts[0].split("]")[1];
                      if (collectionName && collectionName.trim().toLowerCase() === currentCollectionPage.toLowerCase()) {
                        matchedAssetUrl = parts[1].trim();
                        enableBgConsoleLogs && console.log("[MatchFound]", "matchedAssetUrl =>", matchedAssetUrl, "product_title:", variant.product_title);
                      }
                    } else {
                      matchedAssetUrl = item;
                      enableBgConsoleLogs && console.log("[NoCommaCase]", "matchedAssetUrl =>", matchedAssetUrl, "product_title:", variant.product_title);
                    }
                  }
                }
              });

              if (matchedAssetUrl && mainBg) {
                enableBgConsoleLogs && console.log("[plp_leading_asset MATCHED]", matchedAssetUrl, "product_title:", variant.product_title);

                var isVideoMp4 = matchedAssetUrl.toLowerCase().endsWith(".mp4");

                if (isVideoMp4) {
                  mainBg.innerHTML = '<video src="' + matchedAssetUrl + '" autoplay muted loop playsinline style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;"></video>';

                  enableBgConsoleLogs && console.log("[mainBgVideoSet] =>", matchedAssetUrl, "product_title:", variant.product_title);
                } else {
                  mainBg.setAttribute("data-bgset", generateResponsiveDataBgset(matchedAssetUrl));
                  enableBgConsoleLogs && console.log("[mainBgSet] =>", matchedAssetUrl, "product_title:", variant.product_title);
                }
              } else {
                enableBgConsoleLogs && console.log("[No matchedAssetUrl] Using fallback data-bgset", "product_title:", variant.product_title);

                if (bgUnder && variant.featured_media && variant.featured_media.src) {
                  bgUnder.setAttribute("data-bgset", generateResponsiveDataBgset(variant.featured_media.src));
                  enableBgConsoleLogs && console.log("[bgUnderSet] =>", variant.featured_media.src, "product_title:", variant.product_title);
                }

                if (mainBg && firstColorImage) {
                  mainBg.setAttribute("data-bgset", generateResponsiveDataBgset(firstColorImage.src));
                  enableBgConsoleLogs && console.log("[mainBgSet] =>", firstColorImage.src, "product_title:", variant.product_title);
                }
              }
              if (bgUnder && variant.featured_media && variant.featured_media.src) {
                bgUnder.setAttribute("data-bgset", generateResponsiveDataBgset(variant.featured_media.src));
                enableBgConsoleLogs && console.log("[bgUnderSet] =>", variant.featured_media.src, "product_title:", variant.product_title);
              }
            } else {
              enableBgConsoleLogs && console.log("[plp_leading_asset] does NOT exist, using fallback data-bgset", "product_title:", variant.product_title);

              if (bgUnder && variant.featured_media && variant.featured_media.src) {
                bgUnder.setAttribute("data-bgset", generateResponsiveDataBgset(variant.featured_media.src));
                enableBgConsoleLogs && console.log("[bgUnderSet] =>", variant.featured_media.src, "product_title:", variant.product_title);
              }

              if (mainBg && firstColorImage) {
                mainBg.setAttribute("data-bgset", generateResponsiveDataBgset(firstColorImage.src));
                enableBgConsoleLogs && console.log("[mainBgSet] =>", firstColorImage.src, "product_title:", variant.product_title);
              }
            }
            if (firstColorImage && ((variant.featured_media && variant.featured_media.src === firstColorImage.src) || !variant.featured_media)) {
              var filteredImages = imagesObj.product_images.filter(function(img) {
                return img.alt === selectedColorValue;
              });
              if (filteredImages.length >= 2 && bgUnder) {
                bgUnder.setAttribute("data-bgset", generateResponsiveDataBgset(filteredImages[1].src));
                enableBgConsoleLogs && console.log("[bgUnderSet from 2nd image]", filteredImages[1].src, "product_title:", variant.product_title);
              }
            }            
            if (quickAddContainer && bgUnder) {
              quickAddContainer.addEventListener("mouseleave", function () {
                enableBgConsoleLogs && console.log("[HoverEvent]", "#quick-add-container leave", "product_title:", variant.product_title);
                bgUnder.style.opacity = "";
              });
            }

            foundMatch = true;
            break;
          }
        }
      }

      function updateVariantLinkAndPrice(form, explodedColor, relatedVariants) {
        var productItem = form.closest(".product-item");
        if (!productItem) return;

        var productLinkEls = productItem.querySelectorAll(".product-link");
        var matchingVariant = relatedVariants.find(function (v) {
          return v.option1 === explodedColor;
        });

        if (!matchingVariant || productLinkEls.length === 0) return;

        productLinkEls.forEach(function(productLinkEl) {
          var originalHref = productLinkEl.getAttribute("href") || productLinkEl.getAttribute("data-product-link");
          originalHref = originalHref.replace(/(\?|&)variant=\d+/, "");
          originalHref = originalHref.replace(/[?&]$/, "");

          if (originalHref.indexOf('?') === -1) {
            productLinkEl.setAttribute("href", originalHref + "?variant=" + matchingVariant.id);
          } else {
            var parts = originalHref.split("?");
            if (parts.length > 1) {
              var baseUrl = parts[0];
              var queryString = parts[1];
              var queryParts = queryString.split("&").filter(function (param) {
                return param && !param.startsWith("variant=");
              });
              queryParts.push("variant=" + matchingVariant.id);
              var newHref = baseUrl + "?" + queryParts.join("&");
              productLinkEl.setAttribute("href", newHref);
            } else {
              productLinkEl.setAttribute("href", originalHref + "?variant=" + matchingVariant.id);
            }
          }

          if (productLinkEl.hasAttribute("data-product-link")) {
            productLinkEl.setAttribute("data-product-link", productLinkEl.getAttribute("href"));
          }
        });

        var newPriceEl = productItem.querySelector(".new-price");
        var oldPriceEl = productItem.querySelector(".old-price");

        if (!oldPriceEl && newPriceEl && newPriceEl.parentElement) {
          oldPriceEl = document.createElement("span");
          oldPriceEl.className = "old-price";
          newPriceEl.parentElement.insertBefore(oldPriceEl, newPriceEl.nextSibling);
        }

        if (newPriceEl) {
          var symbolMatch = newPriceEl.textContent.trim().match(/[^\d.,]+/);
          var currencySymbol = symbolMatch ? symbolMatch[0] : "";

          function formatPrice(amount) {
            var parts = (amount / 100).toFixed(2).split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            var result = currencySymbol === "$" ? currencySymbol + parts[0] : currencySymbol + parts.join(".");
            return result;
          }

          newPriceEl.textContent = formatPrice(matchingVariant.price);

          if (oldPriceEl) {
            var compareAtPrice = parseFloat(matchingVariant.compare_at_price || 0);
            
            if (compareAtPrice > 0) {
              var formattedPrice = formatPrice(compareAtPrice);
              oldPriceEl.textContent = formattedPrice;
              oldPriceEl.style.display = "inline";
              oldPriceEl.style.visibility = "visible";
              oldPriceEl.style.opacity = "1";
            } else {
              oldPriceEl.textContent = "";
            }
          }
        }

        window.handleFinalSaleNotice(matchingVariant, form);
      }

      // Add colorSwatches mouseenter event
      var colorSwatches = form.querySelectorAll(".quick-add-swatch__button");

      var visibleSwatchButtons = form.querySelectorAll('.quick-add-swatch__button:not(.hide-variant)');
      if (visibleSwatchButtons.length === 1) {
        var productItemEl = form.closest('.product-item');
        visibleSwatchButtons[0].classList.add("hide-swatch");
        productItemEl.classList.add('single-color');
      }
      
      colorSwatches.forEach(function (swatch) {
        swatch.addEventListener("mouseenter", function () {
          enableBgConsoleLogs && console.log("[ColorHover] swatch element:", swatch);

          var label = swatch.querySelector("label");
          if (!(label && label.classList.contains("selected"))) {
            setTimeout(function () {
              var scrollContainer = form.querySelector(".scrollable-options-container");
              if (scrollContainer) {
                scrollContainer.scrollTop = scrollContainer.scrollHeight;
                enableBgConsoleLogs && console.log("[ColorHover] scrolled container to bottom:", scrollContainer);
              }
              applySelectedColorMediaToBgExploded();
            }, 100);
          }

          var productItem = form.closest(".product-item");
          if (!productItem) {
            enableBgConsoleLogs && console.log("[ColorHover] No .product-item found, aborting");
            return;
          }

          var bgUnder = productItem.querySelector(".product-item__bg__under");
          var quickAddContainer = productItem.querySelector("#quick-add-container");
          if (quickAddContainer && bgUnder) {
            bgUnder.style.opacity = 0;
            enableBgConsoleLogs && console.log("[ColorHover] Hiding bgUnder =>", bgUnder);
          }

          var radio = swatch.querySelector("input[data-single-option-selector]");
          if (!radio) {
            enableBgConsoleLogs && console.log("[ColorHover] No radio found in swatch =>", swatch);
            return;
          }
          if (radio.checked) {
            enableBgConsoleLogs && console.log("[ColorHover] Radio already checked =>", radio);
            return;
          }

          radio.checked = true;
          enableBgConsoleLogs && console.log("[ColorHover] Set radio.checked =>", radio.value, " => productId:", productId);

          enableBgConsoleLogs && console.log("[ColorHover] Calling applySelectedColorMediaToBg =>", productId);

          var selectedOption = radio.getAttribute("data-index");
          var sameOptionRadios = form.querySelectorAll('input[data-index="' + selectedOption + '"]');
          sameOptionRadios.forEach(function (rd) {
            var lbl = form.querySelector("label[for='" + rd.id + "']");
            if (lbl) lbl.classList.remove("selected");
          });

          var labelForThis = form.querySelector("label[for='" + radio.id + "']");
          if (labelForThis) {
            labelForThis.classList.add("selected");
            enableBgConsoleLogs && console.log("[ColorHover] Marked label as selected =>", labelForThis);
          }

          explodedColor = radio.value;
          form.setAttribute("data-exploded-color", explodedColor);
          relatedVariants = productData.variants.filter(function (v) {
            return v.title && v.title.indexOf(explodedColor) > -1;
          });
          enableBgConsoleLogs && console.log("[ColorHover] Updated explodedColor to", explodedColor, "for product", form.getAttribute("data-quick-add-exploded-product-id"));

          // Update Swiper gallery to hovered color immediately (exploded PLP parity with default PLP)
          try {
            var productItem = form.closest('.product-item');
            if (productItem && typeof window.rebuildSwiperByColorGlobal === 'function') {
              window.rebuildSwiperByColorGlobal(productItem, explodedColor, { firstOnly: false, maxSlides: 4 });
            }
          } catch(e) {}

          updateVariantLinkAndPrice(form, explodedColor, relatedVariants);
          updateUI();
        });

        swatch.addEventListener("mouseenter", function () {
          updateVariantLinkAndPrice(form, explodedColor, relatedVariants);
        });

        updateVariantLinkAndPrice(form, explodedColor, relatedVariants);
      });

      applySelectedColorMediaToBgExploded();

      setTimeout(function () {
        if (explodedColorId) {
          adjustSizeScrollHeightForProduct(explodedColorId);
        }
      }, 1000);

      window.addEventListener("resize", function () {
        setTimeout(function () {
          adjustSizeScrollHeightForProduct(explodedColorId);
        }, 500);
      });

      var radioLabels = form.querySelectorAll(".quick-add-radio__button label");
      radioLabels.forEach(function (labelEl) {
        labelEl.addEventListener("click", function () {
          if (labelEl.closest(".quick-add-radio__button").classList.contains("no-stock")) {
            return;
          }
          var inputEl = form.querySelector("#" + labelEl.getAttribute("for"));
          if (!inputEl) return;
          inputEl.checked = true;
          var optionIndex = inputEl.getAttribute("data-index");
          var sameOptionRadios = form.querySelectorAll('input[data-index="' + optionIndex + '"]');
          sameOptionRadios.forEach(function (rd) {
            var lbl = form.querySelector('label[for="' + rd.id + '"]');
            if (lbl) lbl.classList.remove("selected");
          });
          labelEl.classList.add("selected");
          
          var isSize = isSizeRadio(inputEl);
          var isOpt3 = isOption3Radio(inputEl);
          
          var hasOption3 = form.querySelector('.quick-add-selector-wrapper--option3') !== null;
          if (hasOption3) {
            var selectedSizeRadio = form.querySelector('.quick-add-selector-wrapper--size input[type="radio"]:checked');
            var selectedOpt3Radio = form.querySelector('.quick-add-selector-wrapper--option3 input[type="radio"]:checked');
            
            if (isSize && !selectedOpt3Radio) {
              form.setAttribute('data-selected-first', 'size');
            } else if (isOpt3 && !selectedSizeRadio) {
              form.setAttribute('data-selected-first', 'option3');
            }
          }
          
          updateUI();
          if (optionIndex === "option3") {
            setTimeout(function () {
              adjustSizeScrollHeightForProduct(explodedColorId);
            }, 100);
          }

          var sizeWrapper = form.querySelector(".quick-add-selector-wrapper--size");
          var selectedSizeRadio = sizeWrapper ? sizeWrapper.querySelector('input[type="radio"]:checked') : null;
          var selectedSizeValue = selectedSizeRadio ? selectedSizeRadio.value : null;
          var opt3Wrapper = form.querySelector(".quick-add-selector-wrapper--option3");
          var selectedOpt3Radio = opt3Wrapper ? opt3Wrapper.querySelector('input[type="radio"]:checked') : null;
          var selectedOpt3Value = selectedOpt3Radio ? selectedOpt3Radio.value : null;
          var chosenOptions = [explodedColor];
          if (selectedSizeValue) chosenOptions.push(selectedSizeValue);
          if (selectedOpt3Value) chosenOptions.push(selectedOpt3Value);
          if (chosenOptions.length < productData.options.length) return;

          var matchingVariant = relatedVariants.find(function (variant) {
            if (variantIsIgnored(variant.id)) return false;
            return variant.options.every(function (optVal, idx) {
              return chosenOptions[idx] === optVal;
            });
          });
          if (!matchingVariant) return;

          window.handleFinalSaleNotice(matchingVariant, form);

          var properties = {};
          var propFields = form.querySelectorAll('input[name^="properties["]');
          propFields.forEach(function(field) {
            var propName = field.name.match(/properties\[(.*?)\]/)[1];
            properties[propName] = field.value;
          });

          form.classList.add("is-loading");
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "xmlhttprequest",
            },
            body: JSON.stringify({
              items: [
                {
                  id: matchingVariant.id,
                  quantity: 1,
                  properties: properties
                },
              ],
            }),
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error("Add to cart error => " + response.statusText);
              }
              return response.json();
            })
            .then(function () {
              if (window.cart && typeof window.cart.getCart === "function") {
                window.cart.getCart();
              }
              if (form.classList.contains("is-loading")) {
                form.classList.remove("is-loading");
              }
              
              var hasOption3 = form.querySelector('.quick-add-selector-wrapper--option3') !== null;
              if (hasOption3) {
                var selectedFirst = form.getAttribute('data-selected-first');
                
                if (selectedFirst === 'size') {
                  var opt3Radio = form.querySelector('.quick-add-selector-wrapper--option3 input[type="radio"]:checked');
                  if (opt3Radio) {
                    opt3Radio.checked = false;
                    var opt3Label = form.querySelector('label[for="' + opt3Radio.id + '"]');
                    if (opt3Label) {
                      opt3Label.classList.remove("selected");
                    }
                  }
                } else if (selectedFirst === 'option3') {
                  var sizeRadio = form.querySelector('.quick-add-selector-wrapper--size input[type="radio"]:checked');
                  if (sizeRadio) {
                    sizeRadio.checked = false;
                    var sizeLabel = form.querySelector('label[for="' + sizeRadio.id + '"]');
                    if (sizeLabel) {
                      sizeLabel.classList.remove("selected");
                    }
                  }
                } else {
                  if (isSize) {
                    inputEl.checked = false;
                    labelEl.classList.remove("selected");
                  }
                }
                
                form.removeAttribute('data-selected-first');
              } else {
                if (isSize) {
                  inputEl.checked = false;
                  labelEl.classList.remove("selected");
                }
              }
              updateUI();
            })
            .catch(function (error) {
              console.error("[Exploded] Error adding to cart:", error);
              if (form.classList.contains("is-loading")) {
                form.classList.remove("is-loading");
              }
            });
        });
      });
    });
  }

  function adjustProductCardHeight() {
    var productTitles = document.querySelectorAll('.product-item__title');
    
    var lowestTitleHeight = Number.MAX_VALUE;
    productTitles.forEach(function(productTitle) {
      var height = productTitle.offsetHeight;
      if (height < lowestTitleHeight && height > 0) {
        lowestTitleHeight = height;
      }
    });
    
    productTitles.forEach(function(productTitle) {
      var productTitleHeight = productTitle.offsetHeight;
      var parent = productTitle.closest('.product-item');
      var productInfo = parent.querySelector('.product-information');
      var swatchesEl = parent.querySelector('.quick-add-selector-wrapper--swatch');
      var heightRatio = Math.floor(productTitleHeight / lowestTitleHeight);
      var adjustment = 0;
      
      if (heightRatio > 1) {
        adjustment = (heightRatio - 1) * lowestTitleHeight;
        
        var stylesApplied = productInfo.getAttribute('data-adjusted');
        var isSwatchesElHidden = window.getComputedStyle(swatchesEl).getPropertyValue('display') === 'none';
        
        if (stylesApplied !== adjustment.toString() && !isSwatchesElHidden) {
          var productInfoHeight = productInfo.offsetHeight;
          var swatchesElTopSpace = parseInt(window.getComputedStyle(swatchesEl).top) || 0;

          productInfo.style.height = (productInfoHeight + adjustment) + 'px';
          swatchesEl.style.top = (swatchesElTopSpace + adjustment) + 'px';

          productInfo.setAttribute('data-adjusted', adjustment.toString());
        }
      } else {
        swatchesEl?.style?.removeProperty("top");
        productInfo?.style?.removeProperty("height");
        productInfo?.removeAttribute('data-adjusted');
      }
    });
  }

  // Use global early-defined function for placement
  var updateSwatchPlacement = window.updateSwatchPlacement;

  window.initProductItemResizeObserver = function initProductItemResizeObserver() {
    var productItem = document.querySelector('.product-item');
    if (!productItem) return;
    adjustProductCardHeight();
    var firstObserverCall = true;
    var debounceTimeout;
    var resizeObserver = new ResizeObserver(function(entries) {
      if (firstObserverCall) {
        firstObserverCall = false;
        return;
      }
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(function() {
        adjustSwatchesWidth();
        adjustProductCardHeight();
        if (typeof updateSwatchPlacement === 'function') { updateSwatchPlacement(); }
      }, 100);
    });
    resizeObserver.observe(productItem);
  }

  initProductItemResizeObserver();
  handleExplodedVariants();
  adjustSwatchesWidth();
  hideSideOptionsOnHover();
  setTimeout(function() {
    checkEmptyProductGrid();
  }, 100);

  // listeners are set up globally above; just do a final call here
  try { if (typeof updateSwatchPlacement === 'function') { updateSwatchPlacement(); } } catch(e) {}

  function updateProductBadge(productItem, variantId, productId) {
    if (!productItem) return;
    
    var badgeContainer = productItem.querySelector('[data-product-badge-container]');
    if (!badgeContainer) return;
    
    var originalBadge = badgeContainer.getAttribute('data-mapped-tag');
    var currentCollectionUrl = badgeContainer.getAttribute('data-current-collection') || "";
    var excludeVariantBadgesData = badgeContainer.getAttribute('data-exclude-variant-badges') || "";
    var excludeVariantBadges = excludeVariantBadgesData ? excludeVariantBadgesData.split('|') : [];
    
    var script = document.querySelector('script[type="application/json"][data-variant-metafields-product-id="' + productId + '"]');
    if (!script) return;
    
    try {
      var variantData = JSON.parse(script.textContent.trim());

      var currentVariant = variantData.find(function(v) {
        return v && v.id === variantId;
      });
      
      if (!currentVariant) return;

      var shouldDisplay = true;
      if (currentVariant.excluded_badge_collections && currentCollectionUrl) {
        shouldDisplay = !currentVariant.excluded_badge_collections.includes(currentCollectionUrl);
      }
      
      var currentColor = currentVariant.color_option;
      var colorVariants = variantData.filter(function(v) {
        return v && v.color_option === currentColor;
      });
      var variantWithBadge = colorVariants.find(function(v) {
        return v && v.product_variant_badge;
      });
      
      var badgeElement = badgeContainer.querySelector('.product-item__item-badge');
      if (!badgeElement) return;

      var badgeText = "";
      var shouldExcludeBadge = false;
      
      if (variantWithBadge && variantWithBadge.product_variant_badge) {
        badgeText = variantWithBadge.product_variant_badge;
        shouldExcludeBadge = excludeVariantBadges.includes(badgeText.toLowerCase());
      } else if (originalBadge) {
        badgeText = originalBadge;
        shouldExcludeBadge = excludeVariantBadges.includes(badgeText.toLowerCase());
      }
  
      if (shouldDisplay && !shouldExcludeBadge) {
        if (badgeText) {
          badgeElement.textContent = badgeText;
          badgeContainer.style.display = 'block';
        } else {
          badgeContainer.style.display = 'none';
        }
      } else {
        badgeContainer.style.display = 'none';
      }
    } catch (e) {
      console.error("Error updating badge:", e);
    }
  }

  function hideProductItemForFilteredColor(wrapper, colorValue, filteredVariants) {
    var allProductColors = {};
    var allFilterColors = new Set();
    
    filteredVariants.forEach(function(variant) {
      if (!variant || !variant.title) return;
      
      var variantTitle = variant.title || '';
      var parts = variantTitle.split(' / ');
      var variantColor = parts[0];
      
      if (variantColor && variant.filter_color) {
        if (!allProductColors[variantColor]) {
          allProductColors[variantColor] = variant.filter_color;
        }
        allFilterColors.add(variant.filter_color);
      }
    });
    
    var colorVariants = filteredVariants.filter(function(variant) {
      if (!variant || !variant.title) return false;
      
      var variantTitle = variant.title || '';
      var variantColor = variantTitle.split(' / ')[0];
      
      return variantColor === colorValue;
    });
    
    var filterColorValues = colorVariants.map(function(variant) {
      return variant.filter_color;
    }).filter(Boolean);
    
    if (filterColorValues.length > 0) {
      var currentFilterColor = filterColorValues[0];
      
      if (currentFilterColor) {
        var currentUrl = new URL(window.location.href);
        var urlColorFilters = currentUrl.searchParams.getAll("filter.v.m.custom.filter_color");
        var productItem = wrapper.closest('.product-item');

        
        var anyColorNotHidden = false;
        
        urlColorFilters.forEach(function(urlFilter) {
          for (var productColor in allProductColors) {
            if (allProductColors[productColor] === urlFilter && productColor !== colorValue) {
              anyColorNotHidden = true;
            }
          }
        });
        
        if (urlColorFilters.length > 0 && urlColorFilters.includes(currentFilterColor) && !anyColorNotHidden) {
          if (productItem) {
            productItem.classList.add('hide-product-item');
          }
        } else {
          if (productItem && productItem.classList.contains('hide-product-item')) {
            productItem.classList.remove('hide-product-item');
          }
        }
      }
    }
  }
};

function markProductGridAsLoaded() {
  var url = new URL(window.location.href);
  var delay = 0;

  if (url.search && url.search.includes('filter.')) {
    checkEmptyProductGrid();
    delay = 100;
  }
  
  var productsContainer = document.querySelector('.product-grid');
  if (productsContainer && !productsContainer.classList.contains('product-grid--loaded')) {
    var addLoaded = function () {
      productsContainer.classList.add('product-grid--loaded');
    };
    
    if (delay) {
      // Reduce delay to keep grid visible quickly on filter
      setTimeout(addLoaded, Math.min(delay, 100));
    } else {
      addLoaded();
    }
  }
}

function filterProductsByExplodedColor() {
  var productsContainer = document.getElementById("CollectionLoop") || document.getElementById("SearchLoop");
  if(!productsContainer) return;
  var url = new URL(window.location.href);
  var currentColorFilters = url.searchParams.getAll("filter.v.m.custom.filter_color");
  
  if (url.search && url.search.includes('filter.')) {
    var inlineMediaItems = productsContainer.querySelectorAll('.product-grid-item--inline-media');
    if (inlineMediaItems.length > 0) {
      inlineMediaItems.forEach(function(item) {
        item.style.display = 'none';
      });
    }
  }
  
  if (productsContainer && productsContainer.getAttribute('data-collection-exploded') === "true" && currentColorFilters.length > 0) {
    productsContainer.style.display = "none";
    var productItems = productsContainer.querySelectorAll('.product-item');
    productItems.forEach(function(item) {
      var itemColor = item.getAttribute('data-exploded-color-name');
      var itemMappedColor = item.getAttribute('data-exploded-mapped-filter-color');
      if(itemMappedColor){
        itemColor = itemMappedColor;
      }
      if (!currentColorFilters.includes(itemColor)) {
        item.remove();
      }
    });

    var remainingItems = productsContainer.querySelectorAll('.product-item').length;
    productsContainer.style.display = "";
    
    checkEmptyProductGrid();
    markProductGridAsLoaded();
    
    requestAnimationFrame(function() {
      initProductItemResizeObserver();
    });
  } else {
    checkEmptyProductGrid();
    markProductGridAsLoaded();
  }
}

function checkEmptyProductGrid() {
  var productsContainer = document.getElementById("CollectionLoop") || document.getElementById("SearchLoop");
  if (!productsContainer) {
    return;
  }
  
  var productItems = productsContainer.querySelectorAll('.product-item');
  var inlineMediaItems = productsContainer.querySelectorAll('.product-grid-item--inline-media');
  var visibleProductItems = productsContainer.querySelectorAll('.product-item:not(.hide-product-item)');
  
  var isEmpty = (productItems.length === 0) || (productItems.length > 0 && visibleProductItems.length === 0);
  
  var emptyProductGridMessage = document.querySelector('.empty-product-grid-message');
  
  if (isEmpty) {
    emptyProductGridMessage.style.display = 'block';
    
    if (inlineMediaItems.length > 0) {
      inlineMediaItems.forEach(function(item) {
        item.style.display = 'none';
      });
    }
  } else {
    emptyProductGridMessage.style.display = 'none';
  }
}

function initRelatedProducts() {
  const container = document.querySelector('.related__wrapper');
  if (container) {
    const id = container.getAttribute('data-section-id');
    const context = {
      id: id,
      container: container,
    };
    let initialized = false;
  const observer = new MutationObserver((mutations, obs) => {
      if (initialized) return;
      const productItems = container.querySelectorAll('.product-item');
      if (productItems && productItems.length > 0) {
        initialized = true;
      // Initialize immediately for snappier UX
      initProductListQuickAdd();
      try { window.collectionSection.onLoad.call(context); } catch(e) {}
      obs.disconnect();
      }
    });
    observer.observe(container, { childList: true, subtree: true });
  }
}

function initProductGridObserver() {
  const productGrid = document.querySelector('.product-grid');
  if (!productGrid) return;
  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        if (!productGrid.classList.contains('product-grid--loaded')) {
          // Mark as loaded immediately to avoid white flashes on load more
          productGrid.classList.add('product-grid--loaded');
        }
      }
    });
  });
  
  observer.observe(productGrid, { 
    childList: true,
    subtree: false,
    attributes: true,
    attributeFilter: ['class']
  });
  
  const filterForm = document.querySelector('form[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('submit', function() {
      // Ensure grid doesn't stay hidden after filter submissions
      setTimeout(function() {
        const updatedGrid = document.querySelector('.product-grid');
        if (updatedGrid && !updatedGrid.classList.contains('product-grid--loaded')) {
          updatedGrid.classList.add('product-grid--loaded');
        }
      }, 100);
    });
  }
}

window.hideInlineMediaOnFilteredViews = function() {
  var productsContainer = document.getElementById("CollectionLoop") || document.getElementById("SearchLoop");
  if (!productsContainer) return;
  var url = new URL(window.location.href);
  var inlineMediaItems = productsContainer.querySelectorAll('.product-grid-item--inline-media');

  if (url.search && url.search.includes('filter.')) {
    if (inlineMediaItems.length > 0) {
      inlineMediaItems.forEach(function(item) {
        item.classList.add('hide-item');
      });
    }
  } else {
    if (inlineMediaItems.length > 0) {
      inlineMediaItems.forEach(function(item) {
        item.classList.remove('hide-item');
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Hide only the size selector (keep color swatches visible) on PLP
  try {
    var sizeWrappers = document.querySelectorAll('#CollectionLoop .quick-add-selector-wrapper--size, #SearchLoop .quick-add-selector-wrapper--size');
    sizeWrappers.forEach(function(el){
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    });
  } catch (e) {}
  window.hideInlineMediaOnFilteredViews();
  initProductListQuickAdd();
  initRelatedProducts();
  filterProductsByExplodedColor();
  initProductGridObserver();
  // Initialize swipers once (no extra listeners to keep PLP snappy)
  if (typeof window.initPLPSwipers === 'function') {
    window.initPLPSwipers();
  }
});



// removed duplicate PLP Swiper init block (handled above)